(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2145],{

/***/ 22636:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customizing/print",
      function () {
        return __webpack_require__(48612);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 67623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ fetchBoards; }
/* harmony export */ });
/* unused harmony export ViewSetBoard */
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants_http__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23359);
/* harmony import */ var _constants_resources__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41238);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



var fetchBoards = function() {
    var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
        var ref, ref1, ref2, res, resData;
        return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    _ctx.next = 3;
                    return (0,_constants_http__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_constants_resources__WEBPACK_IMPORTED_MODULE_2__/* ["default"].BOARDS */ .Z.BOARDS).post(body);
                case 3:
                    res = _ctx.sent;
                    resData = {
                        code: res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.Code,
                        data: res === null || res === void 0 ? void 0 : (ref1 = res.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.Data) === null || ref2 === void 0 ? void 0 : ref2.rows
                    };
                    return _ctx.abrupt("return", resData);
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchBoards(body) {
        return _ref.apply(this, arguments);
    };
}();
var ViewSetBoard = function() {
    var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
        var res;
        return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,_constants_http__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_constants_resources__WEBPACK_IMPORTED_MODULE_2__/* ["default"].BOARDS */ .Z.BOARDS).post(body);
                case 2:
                    res = _ctx.sent;
                    if (!(res.status === 200)) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 7:
                    return _ctx.abrupt("return", res);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function ViewSetBoard(body) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 85134:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ smallPackagingFileAPI; },
/* harmony export */   "t": function() { return /* binding */ smallPackagingAPI; }
/* harmony export */ });
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants_http__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23359);
/* harmony import */ var _constants_resources__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41238);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



var smallPackagingAPI = function() {
    var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
        var res;
        return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,_constants_http__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_constants_resources__WEBPACK_IMPORTED_MODULE_2__/* ["default"].SMALLPACKAGING */ .Z.SMALLPACKAGING).post(body);
                case 2:
                    res = _ctx.sent;
                    if (!(res.status === 200)) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 7:
                    return _ctx.abrupt("return", res);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function smallPackagingAPI(body) {
        return _ref.apply(this, arguments);
    };
}();
var smallPackagingFileAPI = function() {
    var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
        var res;
        return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,_constants_http__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_constants_resources__WEBPACK_IMPORTED_MODULE_2__/* ["default"].SMALLPACKAGING */ .Z.SMALLPACKAGING).postFiles(body);
                case 2:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function smallPackagingFileAPI(body) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 62645:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CustomFileInputWrapper */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _alert__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55150);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  .nonHover {\n    overflow: auto;\n    border-width: 2px;\n    border-style: dashed;\n    border-radius: 10px;\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    height: 100%;\n    min-height: 100px;\n    border-color: ",
        ";\n  }\n\n  .nonHover .header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    border-bottom: 1px solid #6c757d;\n    padding: 10px;\n  }\n\n  .fileList {\n    overflow: auto;\n    padding: 10px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n\n    & .fileName {\n      cursor: pointer;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      transition: none;\n    }\n    & .fileName:hover {\n      color: #3bb77e;\n    }\n\n    & .fileSize {\n      margin-left: 6px;\n      color: rgb(100 116 139);\n    }\n  }\n\n  .fileList:hover {\n    background-color: rgb(203, 213, 225, 0.3);\n  }\n\n  .noFiles {\n    border-style: dashed;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .deleteBtn {\n    cursor: pointer;\n  }\n  .deleteBtn:hover {\n    color: #dc3545;\n  }\n\n  .fileInputHover {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    min-height: 100px;\n    border-style: dashed;\n    border-width: 3px;\n    border-radius: 10px;\n    border-color: #3bb77e;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #3bb77e;\n    cursor: pointer;\n    background-color: #fff;\n  }\n\n  .fileInputLabel {\n    height: 100%;\n    min-height: 100px;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n    margin: 0;\n  }\n\n  .fileInputLabel:hover {\n    color: #3bb77e;\n    background-color: #fff;\n    margin: 0;\n  }\n\n  .fileImg {\n    max-width: 24px;\n    font-size: 24px;\n    font-weight: 300;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var CustomFileInputWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-e8abcfa3-0"
})(_templateObject(), function(props) {
    return props.$error ? "#dc3545" : "#6c757d";
});
var CustomFileInput = function(props) {
    // 각 항목 클릭시 임시 다운로드
    // handleFiles 로 끌어올림
    var handleFiles = props.handleFiles, max = props.max, ment = props.ment, reset = props.reset, error = props.error;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), files = ref1[0], setFiles = ref1[1];
    var hoverRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var nonHoverRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var handleDrop = function(e) {
        e.preventDefault();
        if (hoverRef.current) hoverRef.current.style.visibility = "hidden";
        if (nonHoverRef.current) nonHoverRef.current.style.visibility = "visible";
        var droppedFiles = Array.from(e.dataTransfer.files);
        var tempArr = _toConsumableArray(files).concat(_toConsumableArray(droppedFiles));
        if (max && tempArr.length > max) {
            (0,_alert__WEBPACK_IMPORTED_MODULE_2__/* .failAlert */ .qh)("\uD30C\uC77C\uC740 \uCD5C\uB300 ".concat(max, "\uAC1C\uAE4C\uC9C0 \uAC00\uB2A5\uD569\uB2C8\uB2E4."));
            setFiles(tempArr.slice(0, max));
            return;
        }
        setFiles(tempArr);
    };
    var handleDragOver = function(e) {
        e.preventDefault();
        if (hoverRef.current) hoverRef.current.style.visibility = "visible";
        if (nonHoverRef.current) nonHoverRef.current.style.visibility = "hidden";
    };
    var handleDragLeave = function(e) {
        e.preventDefault();
        if (hoverRef.current) hoverRef.current.style.visibility = "hidden";
        if (nonHoverRef.current) nonHoverRef.current.style.visibility = "visible";
    };
    var onChangeFiles = function(e) {
        var fileList = e.target.files ? Array.from(e.target.files) : [];
        var tempArr = _toConsumableArray(files).concat(_toConsumableArray(fileList));
        if (max && tempArr.length > max) {
            (0,_alert__WEBPACK_IMPORTED_MODULE_2__/* .failAlert */ .qh)("\uD30C\uC77C\uC740 \uCD5C\uB300 ".concat(max, "\uAC1C\uAE4C\uC9C0 \uAC00\uB2A5\uD569\uB2C8\uB2E4."));
            setFiles(tempArr.slice(0, max));
            e.target.value = "";
            return;
        }
        setFiles(tempArr);
        e.target.value = "";
    };
    var deleteFile = function(i) {
        var tempArr = _toConsumableArray(files);
        tempArr.splice(i, 1);
        setFiles(tempArr);
    };
    var fileTypeCheck = function(name) {
        var ref;
        var key = (ref = name.split(".").pop()) === null || ref === void 0 ? void 0 : ref.toLowerCase();
        switch(key){
            case "txt":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/img/fileIcons/txt.png"
                });
            case "doc":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/img/fileIcons/doc.png"
                });
            case "docx":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/img/fileIcons/docx.png"
                });
            case "jpg":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/img/fileIcons/jpg.png"
                });
            case "jpeg":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/img/fileIcons/jpeg.png"
                });
            case "png":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/img/fileIcons/png.png"
                });
            case "gif":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/img/fileIcons/gif.png"
                });
            case "mp3":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/img/fileIcons/mp3.png"
                });
            case "wav":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/img/fileIcons/wav.png"
                });
            case "wmv":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/img/fileIcons/wmv.png"
                });
            case "flac":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/img/fileIcons/flac.png"
                });
            case "mp4":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/img/fileIcons/mp4.png"
                });
            case "avi":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/img/fileIcons/avi.png"
                });
            case "mkv":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/img/fileIcons/mkv.png"
                });
            case "pdf":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/img/fileIcons/pdf.png"
                });
            case "zip":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/img/fileIcons/zip.png"
                });
            case "xls":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/img/fileIcons/xls.png"
                });
            case "ppt":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/img/fileIcons/ppt.png"
                });
            case "pptx":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/img/fileIcons/ppt.png"
                });
            default:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/img/fileIcons/file.png"
                });
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (handleFiles) {
            handleFiles(files);
        }
        if (reset) {
            reset(files);
        }
    }, [
        files
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(CustomFileInputWrapper, {
            className: "d-flex flex-colum w-100 position-relative",
            $error: error,
            children: [
                files && files.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    id: "nonHover",
                    className: "nonHover",
                    onDragOver: handleDragOver,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "header",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "d-flex align-items-center",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                            className: "me-3",
                                            children: [
                                                "\uCCA8\uBD80\uD30C\uC77C ",
                                                files.length,
                                                "\uAC1C"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                            className: "",
                                            children: [
                                                (files.reduce(function(acc, cur) {
                                                    return acc + cur.size;
                                                }, 0) / 1024).toFixed(2),
                                                "KB"
                                            ]
                                        })
                                    ]
                                }),
                                (!max || files.length < max) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                    role: "button",
                                    className: "d-flex align-items-center text-primary",
                                    htmlFor: "fileInput",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                            className: "fi-rs-file-import me-1"
                                        }),
                                        "\uD30C\uC77C \uCD94\uAC00"
                                    ]
                                })
                            ]
                        }),
                        files.map(function(file, i) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "fileList",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "d-flex align-items-center",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "me-2 fileImg",
                                                children: fileTypeCheck(file.name)
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "fileName",
                                                onClick: function() {
                                                    var url = URL.createObjectURL(file);
                                                    var a = document.createElement("a");
                                                    a.href = url;
                                                    a.target = "_blank";
                                                    a.click();
                                                },
                                                children: file.name
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "fileSize",
                                                children: "(" + (file.size / 1024).toFixed(2) + "KB)"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "flex items-center",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "deleteBtn",
                                            onClick: function() {
                                                return deleteFile(i);
                                            },
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                className: "fi-rs-cross w-6 h-6"
                                            })
                                        })
                                    })
                                ]
                            }, i);
                        })
                    ]
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    id: "nonHover",
                    className: "nonHover noFiles",
                    style: {
                        visibility: "visible"
                    },
                    onDragOver: handleDragOver,
                    onDrop: handleDrop,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                            id: "fileInputLabel",
                            htmlFor: "fileInput",
                            className: "fileInputLabel",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                    className: "d-flex align-items-center",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                            className: "fi-rs-file-import me-2"
                                        }),
                                        ment ? ment : "\uD30C\uC77C\uC744 \uB4DC\uB798\uADF8 \uD558\uAC70\uB098 \uD074\uB9AD\uD558\uC138\uC694."
                                    ]
                                }),
                                max && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                    className: "ms-2",
                                    children: [
                                        "(\uCD5C\uB300 ",
                                        max,
                                        "\uAC1C)"
                                    ]
                                })
                            ]
                        })
                    })
                }),
                (!max || files.length < max) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    id: "hover",
                    className: "fileInputHover",
                    style: {
                        visibility: "hidden"
                    },
                    onDragLeave: handleDragLeave,
                    onDrop: handleDrop,
                    onDragOver: handleDragOver,
                    ref: hoverRef,
                    children: "\uD30C\uC77C \uCD94\uAC00"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                    type: "file",
                    multiple: !max || max > 1,
                    id: "fileInput",
                    className: "visually-hidden",
                    onChange: onChangeFiles
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CustomFileInput);


/***/ }),

/***/ 74547:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_daum_postcode__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60007);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: fixed;\n  top: 0;\n  left: 0;\n  background-color: ",
        ";\n  z-index: 100000008;\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  .modal-section {\n    min-width: 40%;\n    background-color: white;\n    border-radius: 20px;\n    overflow: hidden;\n    @media (max-width: 991px) {\n      width: 60%;\n      overflow: auto;\n    }\n    @media (max-width: 767px) {\n      width: 90%;\n      overflow: auto;\n    }\n  }\n\n  .modal-content {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var PostCodeModal = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-44e38a55-0"
})(_templateObject(), function(props) {
    return props.isCheckout ? "" : "rgba(0, 0, 0, 0.8)";
});
var PostCode = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PostCodeModal, {
            onClick: props === null || props === void 0 ? void 0 : props.onClickHandleModal,
            isCheckout: props.isCheckout,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "modal-section",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "modal-content",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_daum_postcode__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
                        style: {
                            height: "470px"
                        },
                        onComplete: props === null || props === void 0 ? void 0 : props.onCompletePostCode
                    })
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PostCode);


/***/ }),

/***/ 89126:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ evidenceCheck; },
/* harmony export */   "v": function() { return /* binding */ autoPhoneFormat; }
/* harmony export */ });
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74231);

var autoPhoneFormat = function(phoneNumber) {
    if ((phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.slice(0, 2)) == "02") {
        var value = phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.replace(/-/g, "").replace(/(\d{2})(\d{4})(\d{4})/, "$1-$2-$3");
        return value;
    } else {
        var value1 = phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.replace(/-/g, "").replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");
        return value1;
    }
};
var evidenceCheck = function(insertNum) {
    var regsplitNum = insertNum.replace(/-/gi, "").split("").map(function(item) {
        return parseInt(item, 10);
    });
    if (regsplitNum.length === 10) {
        var regkey = [
            1,
            3,
            7,
            1,
            3,
            7,
            1,
            3,
            5
        ];
        var regNumSum = 0;
        for(var i = 0; i < regkey.length; i++){
            regNumSum += regkey[i] * regsplitNum[i];
        }
        regNumSum += parseInt(regkey[8] * regsplitNum[8] / 10, 10);
        var regCheck = Math.floor(regsplitNum[9]) === (10 - regNumSum % 10) % 10;
        return regCheck;
    }
};


/***/ }),

/***/ 56516:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C9": function() { return /* binding */ FAQContent; },
/* harmony export */   "SC": function() { return /* binding */ TableRow; },
/* harmony export */   "UZ": function() { return /* binding */ FAQTop; },
/* harmony export */   "l5": function() { return /* binding */ FAQTitle; },
/* harmony export */   "y6": function() { return /* binding */ TableWrapper; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19521);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  border-top: 2px solid black;\n  overflow-x: hidden;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  height: auto;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  border-bottom: 1px solid #ececec;\n  color: black;\n  cursor: pointer;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: ",
        ";\n  color: ",
        ";\n  padding: 0 2rem;\n  -webkit-transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);\n  transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);\n  :hover {\n    background-color: #3bb77e;\n    color: white;\n  }\n  & i {\n    font-size: 1.5rem;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  height: 5rem;\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  display: ",
        ";\n  border-top: 1px solid #ececec;\n  padding: 2rem 2rem;\n  font-weight: 300;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

var TableWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-2c6470e0-0"
})(_templateObject());
var TableRow = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-2c6470e0-1"
})(_templateObject1());
var FAQTop = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-2c6470e0-2"
})(_templateObject2(), function(props) {
    return props.isActive ? "#3bb77e" : "#fff";
}, function(props) {
    return props.isActive ? "#fff" : "black";
});
var FAQTitle = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-2c6470e0-3"
})(_templateObject3());
var FAQContent = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-2c6470e0-4"
})(_templateObject4(), function(props) {
    return props.isActive ? "block" : "none";
});


/***/ }),

/***/ 43774:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: fixed;\n  top: 0;\n  left: 0;\n  background-color: rgba(0, 0, 0, 0.8);\n  z-index: 10000001;\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  & strong {\n    color: #e74c3c;\n  }\n\n  .modal-section {\n    width: fit-content;\n    background-color: white;\n    overflow: auto;\n    border: none;\n    display: flex;\n    flex-direction: column;\n    padding: 30px;\n    border-radius: 10px;\n\n    & > i {\n      font-size: 2rem;\n      color: black;\n      cursor: pointer;\n      :hover {\n        color: #3bb77e;\n      }\n    }\n    @media (max-width: 767px) {\n      padding: 10px;\n    }\n    @media (max-width: 575px) {\n      padding: 10px;\n      width: 90vw;\n    }\n  }\n\n  .modal-content {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding: 1rem;\n    border: none;\n    margin: 0 auto;\n    & h5 {\n      font-size: 18px;\n      margin: 15px 0px;\n      & pre {\n        overflow: visible !important;\n        text-align: center;\n      }\n      @media (max-width: 575px) {\n        font-size: 1rem;\n      }\n    }\n    & img {\n      width: 75%;\n    }\n\n    & a {\n      margin-top: 20px;\n      width: 200px;\n    }\n\n    @media (max-width: 991px) {\n      & a {\n        width: 150px;\n      }\n    }\n    @media (max-width: 767px) {\n      & a {\n        width: 130px;\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var ModalWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-751e3b31-0"
})(_templateObject());
var InquiryCompleteModal = function(param) {
    var onClickInquiryComplete = param.onClickInquiryComplete, confirmText = param.confirmText, confirmImg = param.confirmImg;
    globalThis.onkeydown = function(e) {
        if (e.code === "Escape") return onClickInquiryComplete();
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ModalWrapper, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "modal-section",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "modal-content",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: confirmImg || "/assets/imgs/page/common/inquiry_complete_icon.png"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                            children: confirmText || "\uC18C\uC911\uD55C \uC815\uBCF4 \uAC10\uC0AC\uD569\uB2C8\uB2E4!"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: "btn",
                            onClick: onClickInquiryComplete,
                            children: "\uC644\uB8CC"
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (InquiryCompleteModal);


/***/ }),

/***/ 590:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ KakaoMap; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}


function KakaoMap(props) {
    var address = String(props.address);
    var a = props === null || props === void 0 ? void 0 : props.a;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var script = document.createElement("script");
        script.src = "//dapi.kakao.com/v2/maps/sdk.js?appkey=7ba8898b0f6ed44fb3875c4acd1ec57d&autoload=false&libraries=services ";
        document.head.appendChild(script);
        script.onload = function() {
            window.kakao.maps.load(function() {
                var container = document.getElementById("map"); // 지도를 담을 영역의 DOM 레퍼런스
                var options = {
                    // 지도를 생성할 때 필요한 기본 옵션
                    center: new window.kakao.maps.LatLng(37.544347981356054, 126.958562062053735),
                    level: 3
                };
                var map = new window.kakao.maps.Map(container, options); // 지도 생성 및 객체 리턴
                // const imageSize = new window.kakao.maps.Size(60, 60); // 마커이미지의 크기입니다
                // const imageOption = { offset: new window.kakao.maps.Point(27, 69) }; // 마커이미지의 옵션입니다. 마커의 좌표와 일치시킬 이미지 안에서의 좌표를 설정합니다.
                // const markerImage = new window.kakao.maps.MarkerImage(
                //   imageSize,
                //   imageOption
                // );
                // 주소-좌표 변환 객체를 생성합니다
                var geocoder = new window.kakao.maps.services.Geocoder();
                // 주소로 좌표를 검색합니다
                geocoder.addressSearch(address, function(result, status) {
                    var ref, ref1;
                    props === null || props === void 0 ? void 0 : props.setUserInputs(_objectSpread({}, props === null || props === void 0 ? void 0 : props.userInputs, {
                        addressGps: {
                            mapx: (ref = result[0]) === null || ref === void 0 ? void 0 : ref.x,
                            mapy: (ref1 = result[0]) === null || ref1 === void 0 ? void 0 : ref1.y
                        }
                    }));
                    // 정상적으로 검색이 완료됐으면
                    if (status === window.kakao.maps.services.Status.OK) {
                        var coords = new window.kakao.maps.LatLng(result[0].y, result[0].x);
                        if (props.setGps) props.setGps(coords);
                        // 결과값으로 받은 위치를 마커로 표시합니다
                        var marker = new window.kakao.maps.Marker({
                            map: map,
                            position: coords
                        });
                        // 인포윈도우로 장소에 대한 설명을 표시합니다
                        var info = new window.kakao.maps.InfoWindow({
                            content: '<div style="width:210px;text-align:center;padding:5px 0;">'.concat(address, "</div>")
                        });
                        info.open(map, marker);
                        // 지도의 중심을 결과값으로 받은 위치로 이동시킵니다
                        map.panTo(coords);
                    //   // 지도를 클릭하면 마지막 파라미터로 넘어온 함수를 호출합니다
                    //   window.kakao.maps.event.addListener(
                    //     map,
                    //     "click",
                    //     function (mouseEvent: any) {
                    //       // 클릭한 위도, 경도 정보를 가져옵니다
                    //       const latlng = mouseEvent.latLng;
                    //       // 마커 위치를 클릭한 위치로 옮깁니다
                    //       marker.setPosition(latlng);
                    //     }
                    //   );
                    }
                });
            });
        };
    }, [
        address,
        a
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            id: "map",
            style: {
                width: "100%",
                height: "100%"
            }
        })
    });
};


/***/ }),

/***/ 17461:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64384);
/* harmony import */ var _api_products__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(81628);
/* harmony import */ var _common_auth__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(48106);
/* harmony import */ var _common_splicePrice__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(8025);
/* harmony import */ var _common_util_getDate__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69644);
/* harmony import */ var _redux_action_baskets__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(83173);
/* harmony import */ var _redux_action_cart__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(68866);
/* harmony import */ var _Proucts_list_styles__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(30938);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}













var TableTypeList = function(param) {
    var productList = param.productList, searchList = param.searchList, basketsItems = param.basketsItems, cartItems = param.cartItems, basketsCount = param.basketsCount, dummyList = param.dummyList, _$addToCart = param.addToCart, _$insertBasketsAction = param.insertBasketsAction, purchaseDirect = param.purchaseDirect, addCart = param.addCart, inCart = param.inCart, viewFeature = param.viewFeature, products = param.products;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var inBasket = function(product) {
        return inCart ? inCart(product) : (basketsItems === null || basketsItems === void 0 ? void 0 : basketsItems.find(function(basketsItem) {
            return basketsItem.pcode === product.pcode;
        })) || (cartItems === null || cartItems === void 0 ? void 0 : cartItems.find(function(cartItem) {
            return cartItem.pcode === product.pcode;
        }));
    };
    // 장바구니 담기
    var handleCart = function() {
        var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(product) {
            return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (product) {
                            dataLayer.push({
                                ecommerce: null
                            }); // Clear the previous ecommerce object.
                            dataLayer.push({
                                event: "add_to_cart",
                                ecommerce: {
                                    items: [
                                        {
                                            item_name: product.pname,
                                            item_id: product.pcode,
                                            price: product.price,
                                            item_brand: product.supplier,
                                            item_category: product.category_code.length > 2 ? product.category_code : dummyList === null || dummyList === void 0 ? void 0 : dummyList.category[product.category_code]
                                        }, 
                                    ]
                                }
                            });
                            // 채널톡 장비구니 이벤트
                            window.ChannelIO("track", "AddToCart", {
                                pcode: product.pcode
                            });
                        }
                        if ((0,_common_auth__WEBPACK_IMPORTED_MODULE_7__/* .getCookie */ .ej)("token")) {
                            _ctx.next = 5;
                            break;
                        }
                        return _ctx.abrupt("return", _$addToCart(product));
                    case 5:
                        return _ctx.abrupt("return", _$insertBasketsAction(product, 1));
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleCart(product) {
            return _ref.apply(this, arguments);
        };
    }();
    var moveToDetail = function() {
        var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(product) {
            var body, res, DATE, todays, tempToday, url;
            return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        body = {
                            modes: "ViewCount",
                            pcode: product.pcode
                        };
                        _ctx.next = 3;
                        return (0,_api_products__WEBPACK_IMPORTED_MODULE_6__/* .ViewCountProduct */ .Ir)(body);
                    case 3:
                        res = _ctx.sent;
                        DATE = (0,_common_util_getDate__WEBPACK_IMPORTED_MODULE_10__/* .getDate */ ._3)();
                        todays = JSON.parse(sessionStorage.getItem("".concat(DATE)) || "[]");
                        tempToday = todays.filter(function(el) {
                            return el === product.pcode;
                        });
                        if (!tempToday.length) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 9:
                        todays.push(product.pcode);
                        sessionStorage.setItem("".concat(DATE), JSON.stringify(todays));
                        url = "/products/".concat(product.ename, "/").concat(product.pcode, "/");
                        router.push(url);
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function moveToDetail(product) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Proucts_list_styles__WEBPACK_IMPORTED_MODULE_9__/* .TableTypeWrapper */ .ze, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Proucts_list_styles__WEBPACK_IMPORTED_MODULE_9__/* .Table */ .iA, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("thead", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("tr", {
                            className: "header",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("th", {
                                    className: "img",
                                    children: "\uC774\uBBF8\uC9C0"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("th", {
                                    className: "name",
                                    children: "\uD488\uBA85"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("th", {
                                    className: "sizes",
                                    children: "\uC0AC\uC774\uC988"
                                }),
                                (router.query.code === "01" || router.query.code === "02") && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("th", {
                                            className: "golgi",
                                            children: "\uACE8"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("th", {
                                            className: "strength",
                                            children: "\uC9C0\uC885"
                                        })
                                    ]
                                }),
                                (router.query.code === "05" || viewFeature) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("th", {
                                    className: "feature",
                                    children: "\uC8FC\uC6D0\uB8CC"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("th", {
                                    className: "onePrice",
                                    children: "\uB2E8\uAC00"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("th", {
                                    className: "quantity",
                                    children: "\uBB36\uC74C \uC218\uB7C9"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("th", {
                                    children: "\uD310\uB9E4\uAC00"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("th", {
                                    children: "\uAD6C\uB9E4"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("tbody", {
                        children: (searchList === null || searchList === void 0 ? void 0 : searchList.length) > 0 || (productList === null || productList === void 0 ? void 0 : productList.length) > 0 ? (router.query.search ? searchList : productList).map(function(product, i) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("td", {
                                        className: "img",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                            href: "/products/".concat(product.ename, "/").concat(product.pcode, "/"),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                                onClick: function() {
                                                    return moveToDetail(product);
                                                },
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                                    src: product.main_image,
                                                    alt: product.pname
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("td", {
                                        className: "name",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                            href: "/products/".concat(product.ename, "/").concat(product.pcode, "/"),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                                onClick: function() {
                                                    return moveToDetail(product);
                                                },
                                                children: product.pname
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("td", {
                                        className: "sizes",
                                        children: product.horizontal == 0 && product.vertical == 0 && product.height == 0 ? "-" : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                            children: [
                                                product.horizontal != 0 ? "\uAC00\uB85C: " + product.horizontal : "",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                                                product.vertical != 0 ? "\uC138\uB85C: " + product.vertical : "",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                                                product.height != 0 ? "\uB192\uC774: " + product.height : ""
                                            ]
                                        })
                                    }),
                                    (router.query.code === "01" || router.query.code === "02") && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("td", {
                                                className: "golgi",
                                                children: product.golgi
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("td", {
                                                className: "strength",
                                                children: product.strength
                                            })
                                        ]
                                    }),
                                    (router.query.code === "05" || viewFeature) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("td", {
                                        className: "feature",
                                        children: product.feature ? product.feature : "-"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("td", {
                                        className: "onePrice",
                                        children: Number(product.quantity) < 1 ? "-" : (0,_common_splicePrice__WEBPACK_IMPORTED_MODULE_11__/* .priceComma */ .a)(Math.floor(Number(product.discount_price) / Number(product.quantity))) + "\uC6D0"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("td", {
                                        className: "quantity",
                                        children: product.quantity == 0 ? "-" : (0,_common_splicePrice__WEBPACK_IMPORTED_MODULE_11__/* .priceComma */ .a)(product.quantity) + "\uAC1C"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("td", {
                                        className: "price",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Proucts_list_styles__WEBPACK_IMPORTED_MODULE_9__/* .PriceBox */ .bz, {
                                            children: [
                                                product.salePer > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                        children: product.price && " ".concat((0,_common_splicePrice__WEBPACK_IMPORTED_MODULE_11__/* .priceComma */ .a)(product.price), "\uC6D0")
                                                    })
                                                }),
                                                (0,_common_splicePrice__WEBPACK_IMPORTED_MODULE_11__/* .priceComma */ .a)(product.discount_price),
                                                "\uC6D0"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("td", {
                                        className: "btnWrapper",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Proucts_list_styles__WEBPACK_IMPORTED_MODULE_9__/* .BtnWrapper */ .Bo, {
                                            children: product.sold_out === "Y" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                    children: "\uD488\uC808"
                                                })
                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                                children: [
                                                    purchaseDirect && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Proucts_list_styles__WEBPACK_IMPORTED_MODULE_9__/* .CheckoutBtn */ .$F, {
                                                        onClick: purchaseDirect(product),
                                                        children: "\uBC14\uB85C \uACB0\uC81C\uD558\uAE30"
                                                    }),
                                                    !inBasket(product) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Proucts_list_styles__WEBPACK_IMPORTED_MODULE_9__/* .CartBtn */ .Eo, {
                                                        className: "mobonCart",
                                                        onClick: function() {
                                                            return addCart ? addCart(product) : handleCart(product);
                                                        },
                                                        children: "\uC7A5\uBC14\uAD6C\uB2C8 \uB2F4\uAE30"
                                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Proucts_list_styles__WEBPACK_IMPORTED_MODULE_9__/* .CartBtn */ .Eo, {
                                                        onClick: function() {
                                                            return addCart ? addCart(product) : handleCart(product);
                                                        },
                                                        inCart: true,
                                                        children: "\uC7A5\uBC14\uAD6C\uB2C8 \uB2F4\uAE40"
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            }, i);
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("tr", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("td", {
                                colSpan: 999,
                                children: "\uC870\uAC74\uC5D0 \uB9DE\uB294 \uC0C1\uD488\uC774 \uC5C6\uC2B5\uB2C8\uB2E4."
                            })
                        })
                    })
                ]
            })
        })
    });
};
var mapStateToProps = function(state) {
    return {
        products: state.products,
        cartItems: state.cart,
        basketsItems: state.baskets.items,
        basketsCount: state.baskets.count
    };
};
var mapDispatchToProps = {
    addToCart: _redux_action_cart__WEBPACK_IMPORTED_MODULE_12__/* .addToCart */ .Xq,
    insertBasketsAction: _redux_action_baskets__WEBPACK_IMPORTED_MODULE_8__/* .insertBasketsAction */ .el
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .connect */ .$j)(mapStateToProps, mapDispatchToProps)(TableTypeList));


/***/ }),

/***/ 48612:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ print; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/layout/Layout.js + 36 modules
var Layout = __webpack_require__(49807);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./components/customizing/print/Print.styles.js
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  //padding: 50px 0px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  margin-top: 100px;\n  margin-bottom: 50px;\n  .underbar {\n    opacity: 1;\n    border: 3px solid #3bb77e;\n    width: 60px;\n    margin: 5px 0px;\n  }\n  @media screen and (min-width: 992px) {\n    & h4 {\n      font-size: 40px;\n    }\n    .underbar {\n      margin: 15px 0px 0px 0px;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 30px;\n  padding: 0px 20px;\n  margin-bottom: 50px;\n  @media screen and (min-width: 992px) {\n    margin-bottom: 100px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  > img {\n    margin-bottom: 16px;\n  }\n  & p {\n    font-size: 11px;\n    line-height: 14px;\n    text-align: center;\n    word-break: keep-all;\n    margin: 0px;\n    @media screen and (min-width: 768px) {\n      font-size: 16px;\n      line-height: 20px;\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: 60px;\n  position: relative;\n  .strengthSection {\n    display: none;\n    background-color: #f4f4f4f4;\n    @media screen and (min-width: 992px) {\n      display: block;\n    }\n  }\n  .swiperSection {\n    position: relative;\n    @media screen and (min-width: 992px) {\n      display: none;\n    }\n  }\n  .swiper-slide {\n    padding: 24px;\n    @media screen and (min-width: 768px) {\n      padding: 24px 0px;\n    }\n  }\n  .slider-arrow {\n    display: none;\n    .slider-btn {\n      background-color: #fff;\n      box-shadow: 2px 3px 6px 0px rgba(105, 105, 105, 0.25);\n      :hover {\n        background-color: #3bb77e;\n      }\n    }\n    @media screen and (min-width: 768px) {\n      display: block;\n    }\n  }\n  .swiper-pagination {\n    bottom: -10px;\n    /* .swiper-pagination-bullet {\n      width: 10px !important;\n      height: 10px !important;\n    } */\n  }\n  @media screen and (min-width: 992px) {\n    margin-bottom: 0px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 65px 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  > h6 {\n    color: #2b2b2b !important;\n    font-size: 30px;\n    font-weight: 700;\n    margin: 0px 0px 50px;\n    & strong {\n      color: #3bb77e;\n    }\n  }\n  .strengthGrid {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 30px;\n    .content {\n      overflow: hidden;\n      border-radius: 19px;\n      background: #fff;\n      box-shadow: 3px 6px 10px 0px rgba(0, 0, 0, 0.25);\n      padding: 20px;\n      > img {\n        margin-bottom: 10px;\n      }\n      .desc {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        padding: 10px 0px;\n        text-align: center;\n        > h6 {\n          font-size: 20px;\n          font-weight: 700;\n          margin-bottom: 10px;\n        }\n        > span {\n          font-size: 16px;\n          word-break: keep-all;\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 30px 20px;\n  border-radius: 11px;\n  background: #f9f9f9;\n  box-shadow: 3px 3px 11px 0px rgba(160, 160, 160, 0.25);\n  > h6 {\n    color: #2b2b2b !important;\n    font-weight: 700;\n    margin: 16px 0px;\n    & strong {\n      color: #3bb77e;\n    }\n    @media screen and (min-width: 768px) {\n      font-size: 24px;\n    }\n  }\n  .content {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    @media screen and (min-width: 768px) {\n      > img {\n        max-width: 360px;\n      }\n    }\n  }\n  .desc {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-top: 16px;\n    > h6 {\n      font-size: 14px;\n      margin-bottom: 10px;\n    }\n    > span {\n      font-size: 12px;\n      line-height: 16px;\n      word-break: keep-all;\n      text-align: center;\n    }\n    @media screen and (min-width: 768px) {\n      > h6 {\n        font-size: 20px;\n        margin-bottom: 10px;\n      }\n      > span {\n        font-size: 16px;\n        word-break: keep-all;\n      }\n    }\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  //margin-top: 50px;\n  /* margin-bottom: 50px; */\n  padding: 25px;\n  background-color: #3bb77e;\n  color: #fff;\n  align-items: center;\n\n  .textContent {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n\n  & h6 {\n    color: #fff;\n    font-size: 18px;\n    font-weight: 700;\n    margin-bottom: 16px;\n    word-break: keep-all;\n    text-align: center;\n  }\n  & span {\n    font-size: 15px;\n    font-weight: 400;\n    line-height: 20px;\n    word-break: keep-all;\n    text-align: center;\n    margin-bottom: 16px;\n  }\n  & a {\n    background-color: transparent;\n    border-radius: 18px;\n    border: 1px solid #fff;\n    color: #fff;\n    padding: 5px 15px;\n    font-weight: 700;\n    :hover {\n      background-color: #fff;\n      color: #3bb77e;\n    }\n  }\n  .pc_banner {\n    display: none;\n  }\n  @media screen and (min-width: 768px) {\n    & h6 {\n      font-size: 22px;\n    }\n    & span {\n      font-size: 17px;\n    }\n    & button {\n      padding: 5px 25px;\n    }\n  }\n  @media screen and (min-width: 992px) {\n    flex-direction: row;\n    padding: 0px 25px;\n    .m_banner {\n      display: none;\n    }\n    .pc_banner {\n      display: block;\n    }\n    .textContent {\n      max-width: 1140px;\n      margin: 0 auto;\n      align-items: flex-start;\n      & span {\n        text-align: start;\n      }\n    }\n    .content {\n      display: grid;\n      grid-template-columns: repeat(2, 1fr);\n      align-items: center;\n    }\n    & h6 {\n      font-size: 26px;\n    }\n    & span {\n      font-size: 20px;\n      line-height: 24px;\n      margin-bottom: 30px;\n    }\n    & button {\n      padding: 5px 50px;\n    }\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-bottom: 50px;\n\n  @media screen and (min-width: 992px) {\n    align-items: flex-start;\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 10px;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 10px 20px;\n  > div {\n    position: relative;\n  }\n  .arrow {\n    margin-bottom: 20px;\n  }\n  .stepDeco {\n    position: absolute;\n    border-right: 4px solid #3bb77e;\n    height: 100%;\n    left: -17px;\n    top: 17px;\n    display: none;\n  }\n  .title {\n    color: #3bb77e;\n    font-size: 18px;\n    font-weight: 700;\n    position: relative;\n    .titleDeco {\n      position: absolute;\n      top: 6px;\n      left: -26px;\n      z-index: 10;\n      background-color: #fff;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      padding: 0px 0px 5px 0px;\n      line-height: 13px;\n      vertical-align: text-top;\n      display: none;\n    }\n  }\n  & h6 {\n    word-break: keep-all;\n    text-align: center;\n    margin-bottom: 14px;\n    font-size: 16px;\n    font-weight: 600;\n  }\n  & p {\n    font-size: 12px;\n    line-height: 14px;\n    text-align: center;\n    word-break: keep-all;\n    margin-bottom: 20px;\n  }\n  .pc_direction {\n    display: none;\n  }\n  .m_direction {\n    display: inline;\n  }\n  @media screen and (min-width: 768px) {\n    .title {\n      font-size: 24px;\n    }\n    & h6 {\n      font-size: 20px;\n    }\n    & p {\n      font-size: 14px;\n      line-height: 18px;\n    }\n  }\n  @media screen and (min-width: 992px) {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    margin-top: 50px;\n    .pc_direction {\n      display: inline;\n    }\n    .m_direction {\n      display: none;\n    }\n    .title {\n      font-size: 24px;\n      .titleDeco {\n        display: block;\n      }\n    }\n    & h6 {\n      text-align: start;\n      margin-bottom: 14px;\n      font-size: 20px;\n    }\n    & p {\n      font-size: 18px;\n      line-height: 22px;\n      text-align: start;\n      margin-bottom: 50px;\n    }\n    .arrow {\n      display: none;\n    }\n    .stepDeco {\n      display: block;\n    }\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  padding: 0px 10px;\n\n  .info {\n    display: flex;\n    justify-content: flex-end;\n    font-size: 12px;\n  }\n  .warning {\n    display: flex;\n    justify-content: flex-end;\n    font-size: 12px;\n    color: #ff0000;\n  }\n  @media screen and (min-width: 992px) {\n    .info {\n      font-size: 16px;\n    }\n    .warning {\n      margin-top: 10px;\n      font-size: 16px;\n    }\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 0px auto;\n  border: none;\n  border-radius: 10px;\n  background: #3cb780;\n  color: #fff;\n  padding: 7px 50px;\n  font-size: 16px;\n  :hover {\n    opacity: 0.8;\n  }\n  @media screen and (min-width: 992px) {\n    padding: 10px 80px;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  color: #253d4e;\n  .header {\n    background-color: #f9f6f6ba;\n  }\n  & tr {\n    text-align: center;\n    :hover {\n      background-color: #f9f6f6ba;\n    }\n  }\n\n  & th {\n    padding: 5px;\n    font-size: 14px;\n    word-break: keep-all;\n  }\n\n  & td {\n    padding: 10px;\n  }\n\n  & a {\n    color: #253d4e;\n  }\n\n  .img {\n    width: 10%;\n    padding: 5px;\n    & a {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n    }\n  }\n  .name {\n    width: 35%;\n    & a {\n      overflow: hidden;\n      display: -webkit-box;\n      -webkit-line-clamp: 2;\n      -webkit-box-orient: vertical;\n      white-space: pre-wrap;\n      text-overflow: ellipsis;\n      word-break: keep-all;\n      :hover {\n        color: #3bb77e;\n      }\n    }\n  }\n\n  .price {\n    color: #dc3545;\n  }\n\n  .btnWrapper {\n    width: 10%;\n  }\n\n  .form-check-label::before {\n    margin: 0;\n  }\n  .custome-checkbox {\n    width: fit-content;\n  }\n\n  @media (max-width: 1199px) {\n    & td {\n      white-space: nowrap;\n    }\n    .name {\n      width: 25%;\n    }\n  }\n  @media (max-width: 991px) {\n    & th {\n      font-size: 12px;\n    }\n    & td {\n      font-size: 12px;\n      padding: 5px;\n      white-space: nowrap;\n    }\n    .name {\n      width: 30%;\n    }\n    .sizes {\n      width: 10%;\n    }\n    .onePrice {\n      display: none;\n    }\n    .quantity {\n      width: 10%;\n    }\n    .price {\n      width: 13%;\n    }\n  }\n  @media (max-width: 575px) {\n    & th {\n      font-size: 10px;\n    }\n    & td {\n      font-size: 10px;\n      padding: 5px;\n    }\n    .name {\n      width: 35%;\n    }\n    .sizes {\n      display: none;\n    }\n    .print_price {\n      width: 10%;\n    }\n    .total_price {\n      width: 10%;\n    }\n  }\n  @media (max-width: 460px) {\n    .quantity {\n      display: none;\n    }\n    .onePrice {\n      display: none;\n    }\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: 0;\n\n  & > div {\n    & span {\n      text-decoration: line-through;\n      color: #6c757d;\n      opacity: 0.5;\n    }\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  font-size: 14px;\n  word-break: keep-all;\n  @media (max-width: 991px) {\n    font-size: 14px;\n    line-height: 1.5;\n  }\n  @media (max-width: 767px) {\n    font-size: 10px;\n  }\n  @media (max-width: 575px) {\n    font-size: 8px;\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: 50px;\n  display: flex;\n  flex-direction: column;\n  margin: 50px 0px;\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 31px;\n  font-weight: 400;\n  line-height: 37.52px;\n  text-align: center;\n  color: #3e3e3f;\n  margin: 50px 0px 50px;\n  word-break: keep-all;\n  text-align: center;\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _taggedTemplateLiteral([
        '\n  width: fit-content;\n  font-size: 28px;\n  font-weight: 900;\n  line-height: 33.89px;\n  color: #000000;\n  margin: 25px auto;\n  position: relative;\n  ::after {\n    content: "";\n    position: absolute;\n    width: 100%;\n    left: 0%;\n    bottom: -5px;\n    border-bottom: 3px solid #000000;\n  }\n'
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 28px;\n  font-weight: 900;\n  line-height: 33.89px;\n  text-align: center;\n  word-break: keep-all;\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _taggedTemplateLiteral([
        "\n  width: fit-content;\n  font-size: 31px;\n  font-weight: 400;\n  line-height: 37.52px;\n  color: #3e3e3f;\n  margin: 0px auto 25px;\n  word-break: keep-all;\n  text-align: center;\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 18px;\n  font-weight: 400;\n  line-height: 21.78px;\n  width: fit-content;\n  margin: 0 auto 25px;\n  color: #3e3e3f;\n  word-break: keep-all;\n  text-align: center;\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _taggedTemplateLiteral([
        "\n  width: ",
        ";\n  display: grid;\n  grid-template-columns: ",
        ";\n  gap: 25px;\n  margin: 25px auto;\n\n  @media (max-width: 767px) {\n    width: 100%;\n    grid-template-columns: repeat(1, 1fr);\n  }\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n\n  & img {\n    height: 390px;\n    background-color: #d9d9d9;\n    margin-bottom: 20px;\n  }\n  & span {\n    color: #3e3e3f;\n    font-size: 15px;\n    font-weight: 400;\n    line-height: 18.15px;\n    word-break: keep-all;\n  }\n  @media (max-width: 550px) {\n    & img {\n      height: auto;\n    }\n  }\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = _taggedTemplateLiteral([
        "\n  width: 75%;\n  display: grid;\n  grid-template-columns: ",
        ";\n  gap: 50px;\n  margin: 0px auto;\n  @media (max-width: 767px) {\n    width: 100%;\n    grid-template-columns: repeat(1, 1fr);\n  }\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n\n  & img {\n    width: 100%;\n    max-width: 394px;\n    height: 274px;\n    background-color: #d9d9d9;\n    margin-bottom: 20px;\n  }\n  & span {\n    color: #3e3e3f;\n    font-size: 20px;\n    line-height: 24.2px;\n    font-weight: 400;\n    text-align: center;\n  }\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 50px;\n  padding-bottom: 50px;\n  //border-bottom: 1px solid #dee2e6;\n"
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  margin-bottom: 50px;\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  max-width: 230px;\n  padding: 0px 15px;\n  height: 50px;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  outline: ",
        ";\n  color: ",
        ";\n  z-index: ",
        ";\n  white-space: nowrap;\n  @media (max-width: 991px) {\n    display: none;\n  }\n"
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: none;\n  justify-content: center;\n  align-items: center;\n  @media (max-width: 991px) {\n    display: flex;\n  }\n"
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: repeat(12, 1fr);\n  gap: 30px;\n\n  & img {\n    grid-column: span 7;\n    width: 100%;\n    height: 400px;\n  }\n\n  .description {\n    grid-column: span 5;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n\n    .title {\n      font-size: 18px;\n      font-weight: 700;\n      line-height: 21.78px;\n      color: #000;\n      margin-bottom: 10px;\n    }\n\n    .desc {\n      font-size: 15px;\n      font-weight: 400;\n      line-height: 20px;\n      color: #3e3e3f;\n      word-break: keep-all;\n    }\n    .danger {\n      display: flex;\n      align-items: start;\n      font-size: 15px;\n      font-weight: 400;\n      color: #ff0000;\n      & i {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        margin-right: 5px;\n      }\n      word-break: keep-all;\n    }\n  }\n  @media (max-width: 767px) {\n    display: flex;\n    flex-direction: column;\n    & img {\n      width: 100%;\n      height: auto;\n    }\n  }\n"
    ]);
    _templateObject32 = function _templateObject32() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  .ment {\n    font-size: 14px;\n    font-weight: 400;\n    color: #3e3e3f;\n    margin: 50px 0px 30px;\n  }\n\n  .downloadBtn {\n    margin-bottom: 50px;\n    border: 3px solid #3bb77e;\n    color: #3bb77e;\n    background: #ffffff;\n    width: 166px;\n    height: 50px;\n    font-size: 14px;\n    font-weight: 800;\n    line-height: 16.94px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    & i {\n      display: flex;\n      align-items: center;\n      margin-left: 10px;\n    }\n    :hover {\n      background-color: #3bb77e;\n      color: #fff;\n    }\n  }\n"
    ]);
    _templateObject33 = function _templateObject33() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = _taggedTemplateLiteral([
        "\n  position: sticky;\n  top: 72px; // \uB370\uC2A4\uD06C\uD1B1 \uAE30\uBCF8\uAC12\n  left: 0;\n  width: 100%;\n  background-color: white;\n  z-index: 56;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n  transition: all 0.3s ease;\n\n  @media (max-width: 1200px) {\n    top: 104px;\n  }\n\n  @media (max-width: 1024px) {\n    top: 68px; // \uD0DC\uBE14\uB9BF\uC6A9 \uAC12 \uC870\uC815\n  }\n\n  @media (max-width: 768px) {\n    top: 68px; // \uBAA8\uBC14\uC77C\uC6A9 \uAC12 \uC870\uC815\n  }\n"
    ]);
    _templateObject34 = function _templateObject34() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  justify-content: center;\n  border-bottom: 1px solid #e0e0e0;\n\n  @media (max-width: 768px) {\n    flex-wrap: wrap; /* Allow items to wrap to a new line */\n    justify-content: flex-start; /* Align tabs from the start in mobile */\n    padding: 0 10px; /* Add some padding on the sides */\n    max-height: none; /* Remove max-height restriction */\n    overflow-x: visible; /* Remove horizontal scroll */\n    white-space: normal; /* Allow text to wrap */\n  }\n"
    ]);
    _templateObject35 = function _templateObject35() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 15px 25px;\n  background: none;\n  border: none;\n  font-size: 16px;\n  font-weight: ",
        ";\n  color: ",
        ';\n  position: relative;\n  cursor: pointer;\n  transition: all 0.3s ease;\n\n  &:after {\n    content: "";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 3px;\n    background-color: ',
        ";\n    transition: all 0.3s ease;\n  }\n\n  &:hover {\n    color: #000;\n  }\n\n  @media (max-width: 768px) {\n    padding: 10px 5px;\n    font-size: 14px;\n    flex-shrink: 0;\n    flex-basis: 25%; /* Make each tab take up one-third of the container width */\n    text-align: center;\n\n    /* Adjust the active indicator for the two-row layout */\n    &:after {\n      bottom: 0;\n    }\n  }\n\n  /* For very small screens, still keep three per row */\n  @media (max-width: 480px) {\n    padding: 8px 2px;\n    font-size: 13px;\n    flex-basis: 25%; /* Keep as one-third for three columns */\n  }\n"
    ]);
    _templateObject36 = function _templateObject36() {
        return data;
    };
    return data;
}

var PrintSection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-ace18891-0"
})(_templateObject());
var TopTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ace18891-1"
})(_templateObject1());
var StrengthWarpper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ace18891-2"
})(_templateObject2());
var StrengthBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ace18891-3"
})(_templateObject3());
var StrengthSliderWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ace18891-4"
})(_templateObject4());
var StrengthPC = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ace18891-5"
})(_templateObject5());
var StrengthSlide = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ace18891-6"
})(_templateObject6());
var DesignBanner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ace18891-7"
})(_templateObject7());
var PriceDescWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ace18891-8"
})(_templateObject8());
var Step = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ace18891-9"
})(_templateObject9());
var PriceChart = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ace18891-10"
})(_templateObject10());
var ConfirmBtn = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-ace18891-11"
})(_templateObject11());
// products list
var TableTypeWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ace18891-12"
})(_templateObject12());
var Table = styled_components_browser_esm/* default.table.withConfig */.ZP.table.withConfig({
    componentId: "sc-ace18891-13"
})(_templateObject13());
var PriceBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ace18891-14"
})(_templateObject14());
var BtnWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ace18891-15"
})(_templateObject15());
var ProductInfoFeature = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ace18891-16"
})(_templateObject16());
var ProductSizeBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ace18891-17"
})(_templateObject17());
var NormalTitle = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    componentId: "sc-ace18891-18"
})(_templateObject18());
var NumberUnderBarTitle = styled_components_browser_esm/* default.h6.withConfig */.ZP.h6.withConfig({
    componentId: "sc-ace18891-19"
})(_templateObject19());
var BoldSmallTitle = styled_components_browser_esm/* default.h6.withConfig */.ZP.h6.withConfig({
    componentId: "sc-ace18891-20"
})(_templateObject20());
var MediumTitle = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    componentId: "sc-ace18891-21"
})(_templateObject21());
var TitleDesc = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-ace18891-22"
})(_templateObject22());
var ImgGridWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ace18891-23"
})(_templateObject23(), function(props) {
    return props.length > 1 ? "100%" : "550px";
}, function(props) {
    return props.length > 1 ? "repeat(2, 1fr)" : "repeat(1, 1fr)";
});
var ImgBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ace18891-24"
})(_templateObject24());
var SmallImgGridWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ace18891-25"
})(_templateObject25(), function(props) {
    return props.length > 1 ? "repeat(2, 1fr)" : "repeat(1, 1fr)";
});
var SmallImgBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ace18891-26"
})(_templateObject26());
var ProductInfoSize = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ace18891-27"
})(_templateObject27());
var SizeTabWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ace18891-28"
})(_templateObject28());
var SizeTab = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ace18891-29"
})(_templateObject29(), function(props) {
    return props.active ? "2px solid #3bb77e" : "1px solid #d1d1d1";
}, function(props) {
    return props.active ? "#3bb77e" : "";
}, function(props) {
    return props.active ? "5" : "0";
});
var SizeSelect = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ace18891-30"
})(_templateObject30());
var DesignGuide = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ace18891-31"
})(_templateObject31());
var ImgGuideWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ace18891-32"
})(_templateObject32());
var DesignGuideDownloadWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ace18891-33"
})(_templateObject33());
var TabContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ace18891-34"
})(_templateObject34());
var TabHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ace18891-35"
})(_templateObject35());
var TabItem = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-ace18891-36"
})(_templateObject36(), function(props) {
    return props.active ? "bold" : "normal";
}, function(props) {
    return props.active ? "#000" : "#666";
}, function(props) {
    return props.active ? "#000" : "transparent";
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./components/customizing/print/PrintInquiryModal.js
function PrintInquiryModal_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function PrintInquiryModal_templateObject() {
    var data = PrintInquiryModal_taggedTemplateLiteral([
        '\n  position: fixed;\n  top: 0;\n  left: 0;\n  background-color: rgba(0, 0, 0, 0.8);\n  z-index: 10000001;\n  width: 100vw;\n  height: 100vh;\n\n  & strong {\n    color: #e74c3c;\n  }\n\n  .modal-section {\n    position: fixed;\n    top: 10vh;\n    left: 25vw;\n    width: 50vw;\n    max-height: 80vh;\n    background-color: white;\n    overflow: auto;\n    border: none;\n    display: flex;\n    flex-direction: column;\n    @media screen and (max-width: 991px) {\n      top: 10vh;\n      left: 15vw;\n      width: 70vw;\n      max-height: 80vh;\n    }\n    @media screen and (max-width: 767px) {\n      left: 10vw;\n      width: 80vw;\n    }\n  }\n\n  .header {\n    display: flex;\n    padding: 10px 10px;\n    & img {\n      margin-left: auto;\n      width: 35px;\n      cursor: pointer;\n    }\n  }\n  .title {\n    display: flex;\n    justify-content: center;\n    margin-bottom: 30px;\n    & h4 {\n      color: #3bb77e;\n    }\n  }\n\n  .modal-content {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    border: none;\n    margin: 0 auto;\n    overflow-y: auto;\n    padding: 0px 36px 36px 36px !important;\n    & > span {\n      color: black;\n    }\n  }\n\n  .inputWrapper {\n    width: 100%;\n    margin-bottom: 20px;\n    & h6 {\n      margin-bottom: 10px;\n      ::after {\n        content: "*";\n        margin-left: 2px;\n      }\n    }\n    & input {\n      height: 38px;\n      margin-bottom: 10px;\n      ::placeholder {\n        font-size: 14px;\n        color: #6c757da5;\n      }\n      :focus {\n        border-color: #3bb77e !important;\n        box-shadow: 0 0 0 0.25rem rgba(59, 183, 126, 0.25) !important;\n      }\n    }\n    .col {\n      display: flex;\n      flex-direction: column;\n      width: 50%;\n      & input {\n        width: 100%;\n        padding-right: 0;\n      }\n    }\n    @media screen and (max-width: 575px) {\n      .row {\n        display: flex;\n        flex-direction: column;\n        .col {\n          width: 100%;\n        }\n      }\n    }\n  }\n\n  & textarea {\n    min-height: 150px;\n    ::placeholder {\n      font-size: 14px;\n      color: #6c757da5;\n    }\n    :focus {\n      border-color: #3bb77e !important;\n      box-shadow: 0 0 0 0.25rem rgba(59, 183, 126, 0.25) !important;\n    }\n  }\n  .btnWrapper {\n    width: 100%;\n    & button {\n      width: 100%;\n    }\n  }\n\n  .checkboxWrapper {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    grid-column-gap: 10px;\n    margin-bottom: 20px;\n    @media screen and (max-width: 767px) {\n      grid-template-columns: repeat(2, 1fr);\n    }\n  }\n  .designCheck {\n    margin-bottom: 30px;\n    display: flex;\n    flex-wrap: wrap;\n  }\n'
    ]);
    PrintInquiryModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PrintInquiryModal_templateObject1() {
    var data = PrintInquiryModal_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  margin-right: ",
        ";\n  word-break: keep-all;\n"
    ]);
    PrintInquiryModal_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PrintInquiryModal_templateObject2() {
    var data = PrintInquiryModal_taggedTemplateLiteral([
        "\n  width: ",
        ";\n  font-size: 1rem;\n  padding: ",
        ";\n  overflow: hidden;\n  border: 2px solid #ececec;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background-color: ",
        ";\n  color: #4e4e4e;\n  border-color: ",
        ";\n  border-radius: 10px;\n  position: relative;\n  cursor: pointer;\n\n  & img {\n    margin: 0 auto;\n  }\n\n  .label_title {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    color: #4e4e4e;\n    font-size: 14px;\n    text-align: center;\n\n    & i {\n      padding-top: 1px;\n      :hover {\n        color: #3bb77e;\n      }\n    }\n  }\n"
    ]);
    PrintInquiryModal_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function PrintInquiryModal_templateObject3() {
    var data = PrintInquiryModal_taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  column-gap: 20px;\n  row-gap: 10px;\n  & input {\n    padding: 6px 5px;\n  }\n  @media screen and (max-width: 1200px) {\n    grid-template-columns: repeat(1, 1fr);\n  }\n"
    ]);
    PrintInquiryModal_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var ModalWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-699a6ec4-0"
})(PrintInquiryModal_templateObject());
var CheckBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-699a6ec4-1"
})(PrintInquiryModal_templateObject1(), function(props) {
    return props.design ? "5px" : "0";
});
var CheckBoxLabel = styled_components_browser_esm/* default.label.withConfig */.ZP.label.withConfig({
    componentId: "sc-699a6ec4-2"
})(PrintInquiryModal_templateObject2(), function(props) {
    return props.design ? "fit-content" : "100%";
}, function(props) {
    return props.design ? "10px 20px" : "10px 10px";
}, function(props) {
    return props.checked ? "#d6f2e5" : "#fff";
}, function(props) {
    return props.checked ? "#3bb77e" : "#ececec";
});
var FileWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-699a6ec4-3"
})(PrintInquiryModal_templateObject3());
var PrintInquiryModal = function(param) {
    var onClickInquiry = param.onClickInquiry, submitInquiry = param.submitInquiry, onChangeInquiry = param.onChangeInquiry, inquiryInputs = param.inquiryInputs;
    globalThis.onkeydown = function(e) {
        if (e.code === "Escape") return onClickInquiry();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalWrapper, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "modal-section",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "header",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/assets/imgs/page/common/modal_close_icon.png",
                            alt: "modal_close_icon",
                            onClick: onClickInquiry
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "title",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                            children: "\uC815\uBCF4\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "modal-content",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "inputWrapper",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "row",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "col",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                        children: "\uBB38\uC758\uC790(\uC5C5\uCCB4) \uBA85"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        type: "text",
                                                        onChange: function(e) {
                                                            return onChangeInquiry(e, "name");
                                                        }
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "col",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                        children: "\uBB38\uC758\uC790 \uC5F0\uB77D\uCC98"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        type: "text",
                                                        onChange: function(e) {
                                                            return onChangeInquiry(e, "tel");
                                                        }
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "row",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "col",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                        children: "\uC774\uBA54\uC77C"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        type: "text",
                                                        onChange: function(e) {
                                                            return onChangeInquiry(e, "email");
                                                        }
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "col",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                        children: "\uC218\uB7C9"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        type: "text",
                                                        onChange: function(e) {
                                                            return onChangeInquiry(e, "cnt");
                                                        }
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "row",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "col",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                    children: "\uC778\uC1C4\uB97C \uC6D0\uD558\uB294 \uC0C1\uD488"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: "text",
                                                    onChange: function(e) {
                                                        return onChangeInquiry(e, "usages");
                                                    },
                                                    placeholder: "ex) EL606 \uD0DD\uBC30\uBD09\uD22C (\uC18C)"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "row mb-20",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "col",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                    children: "\uBB38\uC758 \uB0B4\uC6A9"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                                                    type: "text",
                                                    onChange: function(e) {
                                                        return onChangeInquiry(e, "content");
                                                    },
                                                    placeholder: "ex) \uC5B8\uC81C\uAE4C\uC9C0 \uD544\uC694\uD558\uC2E0\uAC00\uC694, \uC5B4\uB5A4 \uB514\uC790\uC778\uC11C\uBE44\uC2A4\uAC00 \uD544\uC694\uD558\uC2E0\uAC00\uC694, \uCD94\uAC00\uC801\uC778 \uBB38\uC758\uC0AC\uD56D\uC744 \uB0A8\uACA8\uC8FC\uC138\uC694"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "row mb-20",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "col",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "h6 text-dark",
                                                    children: "\uCCA8\uBD80 \uD30C\uC77C"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FileWrapper, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            type: "file",
                                                            className: "form-control",
                                                            onChange: function(e) {
                                                                return onChangeInquiry(e, "file1");
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            type: "file",
                                                            className: "form-control",
                                                            onChange: function(e) {
                                                                return onChangeInquiry(e, "file2");
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            type: "file",
                                                            className: "form-control",
                                                            onChange: function(e) {
                                                                return onChangeInquiry(e, "file3");
                                                            }
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "row mb-20",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "col",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "h6 text-dark",
                                                    children: "\uC720\uC758 \uC0AC\uD56D"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                    className: "border rounded p-3",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "1. \uBAA8\uB2C8\uD130\uC758 \uC0C9\uC0C1\uACFC \uCD5C\uC885 \uC778\uC1C4\uBB3C\uC758 \uC0C9\uC0C1\uC740 \uCC28\uC774\uAC00 \uC788\uC744 \uC218 \uC788\uC2B5\uB2C8\uB2E4."
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "2. \uACE0\uC18D \uC778\uC1C4\uC640 \uC7AC\uB2E8 \uACFC\uC815\uC744 \uAC70\uCE58\uBBC0\uB85C \uC778\uC1C4 \uC704\uCE58 \uBC0F \uC0AC\uC774\uC988\uC758 \uC624\uCC28\uAC00 \uBC1C\uC0DD \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4."
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "3. \uC5F4\uD48D\uC5D0 \uC758\uD55C \uAC74\uC870 \uBC29\uC2DD\uC73C\uB85C \uC789\uD06C\uAC00 \uC99D\uBC1C\uD558\uC5EC \uAE30\uD3EC\uAC00 \uC0DD\uAE30\uAC70\uB098 \uC0C9\uC0C1\uC774 \uBE60\uC9C0\uB294 \uACBD\uC6B0\uAC00 \uBC1C\uC0DD\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4."
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "4. \uC778\uC1C4 \uBA74\uC801\uC774 \uB113\uC744 \uC2DC \uBE44\uC6A9\uC774 \uCD94\uAC00 \uB420 \uC218 \uC788\uC2B5\uB2C8\uB2E4. \uB610\uD55C \uC0C9\uC0C1 \uD45C\uD604\uC774 \uACE0\uB974\uC9C0 \uC54A\uAC70\uB098 \uBB3C\uACB0 \uBB34\uB2AC\uAC00 \uC0DD\uAE38 \uC218 \uC788\uC2B5\uB2C8\uB2E4."
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "5. \uC704 \uC0AC\uC720\uB85C \uC778\uD55C \uC7AC\uC791\uC5C5\uC774\uB098 \uBC18\uD488\uC740 \uBD88\uAC00\uD569\uB2C8\uB2E4."
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "6. \uC778\uC1C4 \uAD00\uB828\uB41C \uBB38\uC758\uB294 \uCE7C\uB81B\uC2A4\uD1A0\uC5B4 \uCC44\uB110\uD1A1\uC73C\uB85C \uC5B8\uC81C\uB4E0\uC9C0 \uB0A8\uACA8\uC8FC\uC138\uC694."
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "d-flex flex-row justify-content-start align-items-center",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "custome-checkbox",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                type: "checkbox",
                                                                id: "checkBox1",
                                                                className: "form-check-input",
                                                                onChange: function(e) {
                                                                    return onChangeInquiry(e, "policy");
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                className: "form-check-label",
                                                                htmlFor: "checkBox1",
                                                                style: {
                                                                    textTransform: "capitalize",
                                                                    color: "#696969",
                                                                    fontSize: "16px"
                                                                },
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: "\uC720\uC758\uC0AC\uD56D\uC5D0 \uB3D9\uC758\uD569\uB2C8\uB2E4."
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "btnWrapper",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: "btn",
                                    onClick: submitInquiry,
                                    children: "\uBB38\uC758\uD558\uAE30"
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var print_PrintInquiryModal = (PrintInquiryModal);

// EXTERNAL MODULE: ./common/alert.js
var common_alert = __webpack_require__(55150);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(64384);
// EXTERNAL MODULE: ./api/products.js
var products = __webpack_require__(81628);
// EXTERNAL MODULE: ./components/elements/inquiryCompleteModal.js
var inquiryCompleteModal = __webpack_require__(43774);
// EXTERNAL MODULE: ./redux/action/loading.js
var loading = __webpack_require__(19828);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(30719);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/dist/index.mjs
var dist = __webpack_require__(18357);
;// CONCATENATED MODULE: ./components/customizing/print/Print.data.js
var strengthArr = [
    {
        img: "https://file.caretbio.com/caretbio/d3f17881d53c62b768c375f1861a37e0.png",
        desc: [
            "\uCD5C\uC18C 100\uC7A5\uBD80\uD130 \uC778\uC1C4 \uAC00\uB2A5! \uC18C\uADDC\uBAA8 \uBAA8\uC784, \uAD7F\uC988\uC6A9\uC73C\uB85C \uC88B\uC544\uC694"
        ]
    },
    {
        img: "https://file.caretbio.com/caretbio/5883bfada5b43ef3c3c598834078fdb9.png",
        desc: [
            "\uCD5C\uC18C \uBE44\uC6A9\uC73C\uB85C \uCD5C\uB300 \uB9C8\uCF00\uD305 \uD6A8\uACFC\uB97C",
            "\uBCFC \uC218 \uC788\uC2B5\uB2C8\uB2E4"
        ]
    },
    {
        img: "https://file.caretbio.com/caretbio/4625024a198591171f84a2ee33faf84d.png",
        desc: [
            "\uC778\uC1C4 \uAE30\uAC04\uC740 \uC77C\uC8FC\uC77C!",
            "\uBE60\uB974\uAC8C \uC791\uC5C5\uD558\uC5EC \uBCF4\uB0B4\uB4DC\uB824\uC694"
        ]
    }, 
];
var strengthSlideArr = [
    {
        img: "https://file.caretbio.com/caretbio/c9f2c279f7b9fd0d8ba691e98a7ee08a.png",
        title: "\uB113\uC740 \uC778\uC1C4\uC601\uC5ED",
        desc: "\uCE5C\uD658\uACBD \uC18C\uC7AC \uBD09\uD22C\uC5D0 \uBE0C\uB79C\uB4DC \uB85C\uACE0\uB97C \uB123\uC5B4 \uBE0C\uB79C\uB4DC \uAC00\uCE58\uB97C \uC62C\uB824\uC8FC\uC138\uC694"
    },
    {
        img: "https://file.caretbio.com/caretbio/488787e1a0ee5fd0d844199b8a156c8f.png",
        title: "\uC720\uB7FD\uC0B0 \uC789\uD06C \uC0AC\uC6A9",
        desc: "\uC778\uC1C4 \uD488\uC9C8 \uAE30\uC900\uC774 \uC5C4\uACA9\uD55C \uC720\uB7FD\uC0B0 \uC789\uD06C\uB97C \uC0AC\uC6A9\uD574\uC694"
    },
    {
        img: "https://file.caretbio.com/caretbio/862aad3dcbdbe75508401667fdfdbcba.png",
        title: "\uB2E4\uC591\uD55C \uCEEC\uB7EC\uC640 \uC0AC\uC774\uC988",
        desc: "\uC778\uB514\uD551\uD06C, \uB124\uC628, \uBE14\uB799, \uD06C\uB9BC, \uBC18\uD22C\uBA85\uC18D\uBE44\uB2D0\uAE4C\uC9C0 \uC6A9\uB3C4\uC640 \uBD84\uC704\uAE30\uC5D0 \uB9DE\uAC8C \uC120\uD0DD\uD560 \uC218 \uC788\uC5B4\uC694"
    },
    {
        img: "https://file.caretbio.com/caretbio/621486502fe74265b2490993660a13dd.png",
        title: "\uCE5C\uD658\uACBD \uC18C\uC7AC",
        desc: "\uCE5C\uD658\uACBD \uC7AC\uC0DD \uD0DD\uBC30\uBD09\uD22C(EL606)\uC640 \uBC14\uC774\uC624\uB9E4\uC2A4 \uD0DD\uBC30\uBD09\uD22C(EL727)\uC5D0 \uC18C\uC911\uD55C \uC81C\uD488\uC744 \uB2F4\uC544 \uBCF4\uC138\uC694"
    }, 
];
var SizeData = {
    EL606택배봉투_인디핑크: [
        {
            title: "\uC18C size",
            size: "250mm x 350mm + 40mm",
            desc: "\uC587\uC740 \uC758\uB958, \uC18D\uC637, \uBAA8\uC790\uB97C \uD3EC\uC7A5\uD558\uAE30 \uC801\uD569\uD55C \uC0AC\uC774\uC988 \uC785\uB2C8\uB2E4.",
            imgs: [
                {
                    url: "/assets/imgs/print/info_size/EL606_\uC778\uB514\uD551\uD06C_\uC18C.jpg",
                    desc: ""
                }, 
            ]
        },
        {
            title: "\uC911 size",
            size: "320mm x 400mm + 40mm",
            desc: "\uC154\uCE20, \uB2C8\uD2B8, \uBC14\uC9C0\uB97C \uD3EC\uC7A5\uD558\uAE30 \uC801\uD569\uD55C \uC0AC\uC774\uC988 \uC785\uB2C8\uB2E4.",
            imgs: [
                {
                    url: "/assets/imgs/print/info_size/EL606_\uC778\uB514\uD551\uD06C_\uC911.jpg",
                    desc: ""
                }, 
            ]
        },
        {
            title: "\uB300 size",
            size: "380mm x 470mm + 40mm",
            desc: "\uD6C4\uB4DC\uD2F0, \uB3C4\uD1B0\uD55C \uC758\uB958\uB97C \uD3EC\uC7A5\uD558\uAE30 \uC801\uD569\uD55C \uC0AC\uC774\uC988 \uC785\uB2C8\uB2E4.",
            imgs: [
                {
                    url: "/assets/imgs/print/info_size/EL606_\uC778\uB514\uD551\uD06C_\uB300.jpg",
                    desc: ""
                }, 
            ]
        }, 
    ],
    EL606택배봉투_네온: [
        {
            title: "\uD2B9\uB300 1\uD638 size",
            size: "450mm x 580mm + 40mm",
            desc: "\uC544\uC6B0\uD130 \uB450\uAEBC\uC6B4 \uD6C4\uB4DC\uD2F0\uB97C \uD3EC\uC7A5\uD558\uAE30 \uC801\uD569\uD55C \uC0AC\uC774\uC988 \uC785\uB2C8\uB2E4.",
            imgs: [
                {
                    url: "/assets/imgs/print/info_size/EL606_\uB124\uC628_\uD2B9\uB3001.jpg",
                    desc: ""
                }, 
            ]
        },
        {
            title: "\uD2B9\uB300 2\uD638 size",
            size: "550mm x 800mm + 40mm",
            desc: "\uACA8\uC6B8\uC6A9 \uC544\uC6B0\uD130\uB97C \uD3EC\uC7A5\uD558\uAE30 \uC801\uD569\uD55C \uC0AC\uC774\uC988 \uC785\uB2C8\uB2E4.",
            imgs: [
                {
                    url: "/assets/imgs/print/info_size/EL606_\uB124\uC628_\uD2B9\uB3002.jpg",
                    desc: ""
                }, 
            ]
        },
        {
            title: "\uD2B9\uB300 3\uD638 size",
            size: "700mm x 830mm + 40mm",
            desc: "\uC774\uBD88 \uD328\uB4DC\uB97C \uD3EC\uC7A5\uD558\uAE30 \uC801\uD569\uD55C \uC0AC\uC774\uC988 \uC785\uB2C8\uB2E4.",
            imgs: [
                {
                    url: "/assets/imgs/print/info_size/EL606_\uB124\uC628_\uD2B9\uB3003.jpg",
                    desc: ""
                }, 
            ]
        }, 
    ],
    EL727택배봉투_블랙: [
        {
            title: "\uC911 size",
            size: "320mm x 400mm + 40mm",
            desc: "\uC154\uCE20, \uB2C8\uD2B8, \uBC14\uC9C0\uB97C \uD3EC\uC7A5\uD558\uAE30 \uC801\uD569\uD55C \uC0AC\uC774\uC988 \uC785\uB2C8\uB2E4.",
            imgs: [
                {
                    url: "/assets/imgs/print/info_size/EL727_\uBE14\uB799_\uC911.jpg",
                    desc: ""
                }, 
            ]
        },
        {
            title: "\uB300 size",
            size: "380mm x 470mm + 40mm",
            desc: "\uD6C4\uB4DC\uD2F0, \uB3C4\uD1B0\uD55C \uC758\uB958\uB97C \uD3EC\uC7A5\uD558\uAE30 \uC801\uD569\uD55C \uC0AC\uC774\uC988 \uC785\uB2C8\uB2E4.",
            imgs: [
                {
                    url: "/assets/imgs/print/info_size/EL727_\uBE14\uB799_\uB300.jpg",
                    desc: ""
                }, 
            ]
        }, 
    ],
    EL727택배봉투_아이보리: [
        {
            title: "\uC18C size",
            size: "250mm x 350mm + 40mm",
            desc: "\uC587\uC740 \uC758\uB958, \uC18D\uC637, \uBAA8\uC790\uB97C \uD3EC\uC7A5\uD558\uAE30 \uC801\uD569\uD55C \uC0AC\uC774\uC988 \uC785\uB2C8\uB2E4.",
            imgs: [
                {
                    url: "/assets/imgs/print/info_size/EL727_\uD06C\uB9BC_\uC18C.jpg",
                    desc: ""
                }, 
            ]
        },
        {
            title: "\uC911 size",
            size: "320mm x 400mm + 40mm",
            desc: "\uC154\uCE20, \uB2C8\uD2B8, \uBC14\uC9C0\uB97C \uD3EC\uC7A5\uD558\uAE30 \uC801\uD569\uD55C \uC0AC\uC774\uC988 \uC785\uB2C8\uB2E4.",
            imgs: [
                {
                    url: "/assets/imgs/print/info_size/EL727_\uD06C\uB9BC_\uC911.jpg",
                    desc: ""
                }, 
            ]
        },
        {
            title: "\uB300 size",
            size: "380mm x 470mm + 40mm",
            desc: "\uD6C4\uB4DC\uD2F0, \uB3C4\uD1B0\uD55C \uC758\uB958\uB97C \uD3EC\uC7A5\uD558\uAE30 \uC801\uD569\uD55C \uC0AC\uC774\uC988 \uC785\uB2C8\uB2E4.",
            imgs: [
                {
                    url: "/assets/imgs/print/info_size/EL727_\uD06C\uB9BC_\uB300.jpg",
                    desc: ""
                }, 
            ]
        },
        {
            title: "\uD2B9\uB300 size",
            size: "450mm x 580mm + 40mm",
            desc: "\uC544\uC6B0\uD130 \uB450\uAEBC\uC6B4 \uD6C4\uB4DC\uD2F0\uB97C \uD3EC\uC7A5\uD558\uAE30 \uC801\uD569\uD55C \uC0AC\uC774\uC988 \uC785\uB2C8\uB2E4.",
            imgs: [
                {
                    url: "/assets/imgs/print/info_size/EL727_\uD06C\uB9BC_\uD2B9\uB300.jpg",
                    desc: ""
                }, 
            ]
        }, 
    ],
    EL727속비닐봉투_반투명: [
        {
            title: "\uBBF8\uB2C8 size",
            size: "110mm x 170mm + 40mm",
            desc: "\uCE74\uB4DC \uC545\uC138\uC0AC\uB9AC \uC0AC\uC9C4\uC744 \uD3EC\uC7A5\uD558\uAE30 \uC801\uD569\uD55C \uC0AC\uC774\uC988 \uC785\uB2C8\uB2E4.",
            imgs: [
                {
                    url: "/assets/imgs/print/info_size/EL727_\uBC18\uD22C\uBA85_\uBBF8\uB2C8.jpg",
                    desc: ""
                }, 
            ]
        },
        {
            title: "\uD2B9\uC18C size",
            size: "170mm x 250mm + 40mm",
            desc: "\uC218\uCCA9 \uD578\uB4DC\uD3F0\uCF00\uC774\uC2A4\uB97C \uD3EC\uC7A5\uD558\uAE30 \uC801\uD569\uD55C \uC0AC\uC774\uC988 \uC785\uB2C8\uB2E4.",
            imgs: [
                {
                    url: "/assets/imgs/print/info_size/EL727_\uBC18\uD22C\uBA85_\uD2B9\uC18C.jpg",
                    desc: ""
                }, 
            ]
        },
        {
            title: "\uC18C size",
            size: "250mm x 350mm + 40mm",
            desc: "\uC587\uC740 \uC758\uB958, \uC18D\uC637, \uBAA8\uC790\uB97C \uD3EC\uC7A5\uD558\uAE30 \uC801\uD569\uD55C \uC0AC\uC774\uC988 \uC785\uB2C8\uB2E4.",
            imgs: [
                {
                    url: "/assets/imgs/print/info_size/EL727_\uBC18\uD22C\uBA85_\uC18C.jpg",
                    desc: ""
                }, 
            ]
        },
        {
            title: "\uC911 size",
            size: "320mm x 400mm + 40mm",
            desc: "\uC154\uCE20, \uB2C8\uD2B8, \uBC14\uC9C0\uB97C \uD3EC\uC7A5\uD558\uAE30 \uC801\uD569\uD55C \uC0AC\uC774\uC988 \uC785\uB2C8\uB2E4.",
            imgs: [
                {
                    url: "/assets/imgs/print/info_size/EL727_\uBC18\uD22C\uBA85_\uC911.jpg",
                    desc: ""
                }, 
            ]
        },
        {
            title: "\uB300 size",
            size: "380mm x 470mm + 40mm",
            desc: "\uD6C4\uB4DC\uD2F0, \uB3C4\uD1B0\uD55C \uC758\uB958\uB97C \uD3EC\uC7A5\uD558\uAE30 \uC801\uD569\uD55C \uC0AC\uC774\uC988 \uC785\uB2C8\uB2E4.",
            imgs: [
                {
                    url: "/assets/imgs/print/info_size/EL727_\uBC18\uD22C\uBA85_\uB300.jpg",
                    desc: ""
                }, 
            ]
        }, 
    ]
};

// EXTERNAL MODULE: ./components/filterList/FilterList.js + 3 modules
var FilterList = __webpack_require__(85830);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./components/customizing/print/printCart/PrintCart.styles.js
function PrintCart_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function PrintCart_styles_templateObject() {
    var data = PrintCart_styles_taggedTemplateLiteral([
        "\n  margin-top: 50px;\n  margin-bottom: 50px;\n"
    ]);
    PrintCart_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PrintCart_styles_templateObject1() {
    var data = PrintCart_styles_taggedTemplateLiteral([
        "\n  & h2 {\n    margin-bottom: 20px;\n  }\n"
    ]);
    PrintCart_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PrintCart_styles_templateObject2() {
    var data = PrintCart_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  margin-top: 30px;\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  grid-column-gap: 10px;\n  grid-row-gap: 10px;\n  margin-bottom: 20px;\n  @media screen and (max-width: 767px) {\n    grid-template-columns: repeat(1, 1fr);\n  }\n"
    ]);
    PrintCart_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function PrintCart_styles_templateObject3() {
    var data = PrintCart_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  min-height: 30rem;\n  border: 1px solid #ececec;\n  border-radius: 10px;\n  padding: 20px;\n  position: relative;\n  background-color: white;\n  display: flex;\n  flex-direction: column;\n  color: black;\n\n  :last-of-type {\n    margin-right: 0;\n  }\n\n  .title {\n    margin-bottom: 20px;\n    padding-bottom: 10px;\n    border-bottom: 1px solid #ececec;\n  }\n"
    ]);
    PrintCart_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function PrintCart_styles_templateObject4() {
    var data = PrintCart_styles_taggedTemplateLiteral([
        "\n  width: ",
        ";\n  display: flex;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  margin-bottom: 1rem;\n  align-items: center;\n\n  @media (max-width: 460px) {\n    flex-wrap: wrap;\n  }\n"
    ]);
    PrintCart_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function PrintCart_styles_templateObject5() {
    var data = PrintCart_styles_taggedTemplateLiteral([
        "\n  width: ",
        ";\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 20px;\n  :last-of-type {\n    margin-bottom: 0;\n  }\n\n  .form-control {\n    width: 70%;\n    display: flex;\n    height: 30px;\n    padding: 0px 20px;\n    text-align: center;\n    margin-right: 10px;\n    margin-bottom: 10px;\n    :last-of-type {\n      margin-right: 0px;\n    }\n  }\n\n  .env-policy {\n    display: flex;\n    align-items: center;\n\n    & label {\n      margin-right: 5px;\n      cursor: pointer;\n    }\n    .policy {\n      cursor: pointer;\n    }\n  }\n\n  .custome-checkbox {\n    margin: 0 !important;\n    & label {\n      ::before {\n        margin-bottom: 3px;\n      }\n    }\n  }\n\n  & textarea {\n    min-height: 120px;\n  }\n\n  .btn-md {\n    padding: 5px 10px !important;\n  }\n"
    ]);
    PrintCart_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function PrintCart_styles_templateObject6() {
    var data = PrintCart_styles_taggedTemplateLiteral([
        "\n  width: ",
        " !important;\n  min-width: 70px !important;\n  font-size: 1rem;\n  word-break: keep-all;\n  display: flex;\n"
    ]);
    PrintCart_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function PrintCart_styles_templateObject7() {
    var data = PrintCart_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  min-width: 200px !important;\n  font-size: 1rem;\n  word-break: keep-all;\n  margin-bottom: 10px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-right: 10px;\n  .example {\n    background-color: #3bb77e;\n    padding: 5px;\n    color: #fff;\n    font-size: 0.8rem;\n  }\n"
    ]);
    PrintCart_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function PrintCart_styles_templateObject8() {
    var data = PrintCart_styles_taggedTemplateLiteral([
        "\n  border: 1px solid #ececec;\n  height: 40px;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  padding-left: 20px;\n  font-size: 16px;\n  width: ",
        ";\n  width: ",
        ";\n  margin-right: 1rem;\n\n  :last-child {\n    margin: 0;\n  }\n\n  :focus {\n    background: transparent;\n    border-color: #bce3c9;\n  }\n  @media (max-width: 1199px) {\n    width: 100%;\n  }\n  @media (max-width: 460px) {\n    width: 70%;\n    :nth-of-type(2) {\n      width: 75%;\n      margin-left: 0;\n    }\n  }\n"
    ]);
    PrintCart_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function PrintCart_styles_templateObject9() {
    var data = PrintCart_styles_taggedTemplateLiteral([
        "\n  width: 80%;\n  min-width: 80px !important;\n  height: 40px;\n  padding-left: 10px;\n  border-radius: 10px;\n  border: 1px solid #ececec;\n  margin-right: 1rem;\n  color: #253d4e;\n\n  @media (max-width: 460px) {\n    width: 70%;\n  }\n"
    ]);
    PrintCart_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function PrintCart_styles_templateObject10() {
    var data = PrintCart_styles_taggedTemplateLiteral([
        "\n  width: 50%;\n  height: 40px;\n  text-align: center;\n  font-size: 14px;\n  font-weight: 700;\n  padding: 0;\n  color: #fff;\n  word-break: keep-all;\n  border: 1px solid transparent;\n  background-color: ",
        ";\n  cursor: pointer;\n  border-radius: 10px;\n  :hover {\n    background: #fdc040 !important;\n  }\n  @media (max-width: 1199px) {\n    width: 50%;\n  }\n  @media (max-width: 460px) {\n    font-size: 12px;\n  }\n"
    ]);
    PrintCart_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function PrintCart_styles_templateObject11() {
    var data = PrintCart_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  margin-bottom: 1rem;\n  align-items: center;\n  & div {\n    width: 50%;\n  }\n  & input {\n    height: 40px;\n    width: calc(50% - 16px);\n    min-width: 65px;\n    margin-left: 16px;\n    text-align: center;\n    padding: 0;\n  }\n  @media (max-width: 1199px) {\n    & div {\n      width: 100%;\n    }\n    & input {\n      width: calc(50% - 16px);\n    }\n  }\n\n  @media (max-width: 460px) {\n    & div {\n      width: 70%;\n    }\n    & input {\n      width: calc(50% - 16px);\n    }\n  }\n"
    ]);
    PrintCart_styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function PrintCart_styles_templateObject12() {
    var data = PrintCart_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  & input {\n    display: none;\n  }\n\n  & ul {\n    width: 70%;\n  }\n  & li {\n    width: 100%;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: pre-wrap;\n    display: -webkit-box;\n    -webkit-line-clamp: 1;\n    -webkit-box-orient: vertical;\n    word-break: break-all;\n    margin: 0;\n  }\n\n  .delete_file_btn {\n    color: red;\n    cursor: pointer;\n    :hover {\n      color: orange;\n    }\n  }\n"
    ]);
    PrintCart_styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function PrintCart_styles_templateObject13() {
    var data = PrintCart_styles_taggedTemplateLiteral([
        "\n  width: 30%;\n  padding: 10px;\n  cursor: pointer;\n  border: 1px dashed #ececec;\n  text-align: center;\n  margin-right: 10px;\n  @media screen and (max-width: 1200px) {\n    width: 50%;\n  }\n"
    ]);
    PrintCart_styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function PrintCart_styles_templateObject14() {
    var data = PrintCart_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  & span {\n    text-align: end;\n    margin-bottom: 10px;\n  }\n\n  & table {\n    text-align: center;\n    @media screen and (max-width: 767px) {\n      display: none;\n    }\n  }\n\n  .info {\n    > div {\n      display: flex;\n      align-items: center;\n      word-break: keep-all;\n    }\n    & img {\n      max-width: 50px;\n    }\n  }\n  & td {\n    word-break: keep-all;\n  }\n\n  .btn-primary {\n    :hover {\n      border-color: #fdc040;\n    }\n  }\n\n  .btn-danger {\n    background-color: #dc3545;\n    :hover {\n      border-color: #fd7e14;\n      background-color: #fd7e14;\n    }\n  }\n\n  .custome-checkbox .form-check-label::before {\n    margin: 0;\n  }\n"
    ]);
    PrintCart_styles_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function PrintCart_styles_templateObject15() {
    var data = PrintCart_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  justify-content: end;\n\n  & button {\n    margin-right: 10px;\n    :last-of-type {\n      margin-right: 0;\n    }\n  }\n"
    ]);
    PrintCart_styles_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function PrintCart_styles_templateObject16() {
    var data = PrintCart_styles_taggedTemplateLiteral([
        "\n  display: none;\n\n  @media (max-width: 767px) {\n    display: flex;\n    flex-direction: column;\n  }\n"
    ]);
    PrintCart_styles_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function PrintCart_styles_templateObject17() {
    var data = PrintCart_styles_taggedTemplateLiteral([
        "\n  display: none;\n\n  @media (max-width: 767px) {\n    width: 100%;\n    display: flex;\n    margin-top: 1rem;\n    margin-bottom: 1rem;\n    padding-bottom: 1rem;\n    border-bottom: 1px solid #ececec;\n  }\n"
    ]);
    PrintCart_styles_templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function PrintCart_styles_templateObject18() {
    var data = PrintCart_styles_taggedTemplateLiteral([
        "\n  width: 20%;\n  margin-right: 5%;\n  & img {\n    width: 100%;\n  }\n"
    ]);
    PrintCart_styles_templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function PrintCart_styles_templateObject19() {
    var data = PrintCart_styles_taggedTemplateLiteral([
        "\n  width: 75%;\n  display: none;\n  flex-direction: column;\n  align-items: flex-start;\n  cursor: pointer;\n  @media screen and (max-width: 767px) {\n    display: flex;\n  }\n\n  & h6 {\n    width: 100%;\n    font-weight: 500;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: pre-wrap;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    margin-bottom: 10px;\n    font-size: 20px;\n    :hover {\n      color: #3bb77e;\n    }\n  }\n  & span {\n    margin-bottom: 10px;\n    font-size: 16px;\n  }\n  & div {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    word-break: keep-all;\n    & span {\n      width: 100%;\n      display: flex;\n      text-align: start;\n    }\n  }\n\n  .btn_wrapper {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: end;\n    margin-left: auto;\n  }\n\n  @media (max-width: 575px) {\n    & h6 {\n      font-size: 18px;\n    }\n    & span {\n      font-size: 16px;\n    }\n    & div {\n      & h6 {\n        font-size: 16px;\n      }\n    }\n  }\n  @media (max-width: 424px) {\n    & h6 {\n      font-size: 16px;\n    }\n    & span {\n      font-size: 14px;\n    }\n  }\n"
    ]);
    PrintCart_styles_templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function PrintCart_styles_templateObject20() {
    var data = PrintCart_styles_taggedTemplateLiteral([
        "\n  border: 1px solid #3bb77e;\n  background-color: #3bb77e;\n  border-radius: 100%;\n  width: 36px;\n  height: 36px;\n  font-size: 18px;\n  margin: auto;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: #fff;\n  padding: 5px;\n  cursor: pointer;\n  :hover {\n    opacity: 0.8;\n  }\n  & i {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n"
    ]);
    PrintCart_styles_templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}

var Container = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-876c4427-0"
})(PrintCart_styles_templateObject());
var CartWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-876c4427-1"
})(PrintCart_styles_templateObject1());
var InfoWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-876c4427-2"
})(PrintCart_styles_templateObject2());
var InfoBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-876c4427-3"
})(PrintCart_styles_templateObject3());
var FormInputRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-876c4427-4"
})(PrintCart_styles_templateObject4(), function(props) {
    return props.half ? "50%" : "100%";
});
var FormInputLargeRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-876c4427-5"
})(PrintCart_styles_templateObject5(), function(props) {
    return props.half ? "50%" : "100%";
});
// span
var FormInputBasicSpan = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-876c4427-6"
})(PrintCart_styles_templateObject6(), function(props) {
    return props.large ? "30%" : "15%";
});
// 100% span
var FormInputLargeSpan = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-876c4427-7"
})(PrintCart_styles_templateObject7());
// input
var FormInputBasicInput = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    componentId: "sc-876c4427-8"
})(PrintCart_styles_templateObject8(), function(props) {
    return props.address ? "50%" : "50%";
}, function(props) {
    return props.full && "100%";
});
// select
var FormInputBasicSelect = styled_components_browser_esm/* default.select.withConfig */.ZP.select.withConfig({
    componentId: "sc-876c4427-9"
})(PrintCart_styles_templateObject9());
var FormBasicBtn = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-876c4427-10"
})(PrintCart_styles_templateObject10(), function(props) {
    return props.isCheckingTime ? "#ececec" : "#3bb77e";
});
// 주소 검색
var AddressSearch = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-876c4427-11"
})(PrintCart_styles_templateObject11());
var FileUploadWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-876c4427-12"
})(PrintCart_styles_templateObject12());
var FileUploadLabel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-876c4427-13"
})(PrintCart_styles_templateObject13());
var CartTableWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-876c4427-14"
})(PrintCart_styles_templateObject14());
var CartBtnWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-876c4427-15"
})(PrintCart_styles_templateObject15());
var MobileCartWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-876c4427-16"
})(PrintCart_styles_templateObject16());
// 모바일 상품
var CartProductsMobile = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-876c4427-17"
})(PrintCart_styles_templateObject17());
var ProductMobileImg = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-876c4427-18"
})(PrintCart_styles_templateObject18());
var ProductMobileInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-876c4427-19"
})(PrintCart_styles_templateObject19());
// 모바일 상품 끝
var PlusIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-876c4427-20"
})(PrintCart_styles_templateObject20());

// EXTERNAL MODULE: ./redux/action/confirm.js
var action_confirm = __webpack_require__(94184);
// EXTERNAL MODULE: ./common/splicePrice.js
var splicePrice = __webpack_require__(8025);
// EXTERNAL MODULE: ./common/postcode.js
var postcode = __webpack_require__(74547);
// EXTERNAL MODULE: ./components/map/Maptainer.js
var Maptainer = __webpack_require__(590);
// EXTERNAL MODULE: ./common/CustomFileInput.js
var CustomFileInput = __webpack_require__(62645);
// EXTERNAL MODULE: ./api/smallPackaging.js
var smallPackaging = __webpack_require__(85134);
// EXTERNAL MODULE: ./common/util/checkout-validation.js
var checkout_validation = __webpack_require__(89126);
// EXTERNAL MODULE: ./redux/action/defaultModal.js
var defaultModal = __webpack_require__(84439);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/customizing/print/printCart/PrintCart.js
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

















var PrintCart = function(param) {
    var _$openConfirmModal = param.openConfirmModal, _$modifyConfirmModal = param.modifyConfirmModal, _$closeConfirmModal = param.closeConfirmModal, _$isLoaded = param.isLoaded, _$isLoading = param.isLoading, userInfo = param.userInfo, printCartItems = param.printCartItems, setPrintCartItems = param.setPrintCartItems, userCompany = param.userCompany, moveToList = param.moveToList, _$closeDefaultModal = param.closeDefaultModal, _$modifyDefaultModal = param.modifyDefaultModal, _$openDefaultModal = param.openDefaultModal;
    var ref14, ref1, ref2;
    var router = (0,next_router.useRouter)();
    var ref3 = (0,react.useState)(false), isOpen = ref3[0], setIsOpen = ref3[1];
    var ref4 = (0,react.useState)(""), pickAddress = ref4[0], setPickAddress = ref4[1];
    var ref5 = (0,react.useState)({}), userInputs = ref5[0], setUserInputs = ref5[1];
    var ref6 = (0,react.useState)([]), infoFiles = ref6[0], setInfoFiles = ref6[1];
    // 선택 견적
    var ref7 = (0,react.useState)([]), selectedItem = ref7[0], setSelectedItem = ref7[1];
    var ref8 = (0,react.useState)([]), confirmItems = ref8[0], setConfirmItems = ref8[1];
    // 수량 변경
    var handleCnt = function(e, pcode) {
        var item = printCartItems.find(function(el) {
            return el.pcode === pcode;
        });
        if (Number(e.target.value) > 1000) return;
        if (Number(e.target.value) > 0) {
            item.cnt = e.target.value;
        } else {
            item.cnt = 1;
        }
        setPrintCartItems(_toConsumableArray(printCartItems));
    };
    // 장바구니 삭제
    var deleteBasketItem = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee1(pcode) {
            var content;
            return runtime_default().wrap(function _callee$(_ctx1) {
                while(1)switch(_ctx1.prev = _ctx1.next){
                    case 0:
                        content = {
                            title: "\uC0AD\uC81C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
                            actionBtnLabel: "\uD655\uC778",
                            actionBtnValid: true,
                            cancelBtnLabel: "\uCDE8\uC18C",
                            onAction: _asyncToGenerator(runtime_default().mark(function _callee() {
                                var index;
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            index = printCartItems.findIndex(function(el) {
                                                return el.pcode === pcode;
                                            });
                                            printCartItems.splice(index, 1);
                                            setPrintCartItems(_toConsumableArray(printCartItems));
                                            sessionStorage.setItem("printCart", JSON.stringify(_toConsumableArray(printCartItems)));
                                            (0,common_alert/* successAlert */.Cq)("\uC0AD\uC81C\uB418\uC5C8\uC2B5\uB2C8\uB2E4.");
                                            _$closeConfirmModal();
                                        case 6:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            }))
                        };
                        _$modifyConfirmModal(content);
                        _$openConfirmModal();
                    case 3:
                    case "end":
                        return _ctx1.stop();
                }
            }, _callee1);
        }));
        return function deleteBasketItem(pcode) {
            return _ref.apply(this, arguments);
        };
    }();
    // 입력 값 적용
    var onChangeUserInputs = function(id) {
        return function(e) {
            if (id === "phone" || id === "receipt_num") {
                setUserInputs(_objectSpread({}, userInputs, _defineProperty({}, id, e.target.value)));
                e.target.value = (0,checkout_validation/* autoPhoneFormat */.v)(e.target.value);
                return;
            }
            setUserInputs(_objectSpread({}, userInputs, _defineProperty({}, id, e.target.value)));
        };
    };
    var onChangeFiles = function(files) {
        setInfoFiles(_toConsumableArray(files));
    };
    // 우편번호 검색
    var onClickHandleModal = function() {
        setIsOpen(function(prev) {
            return !prev;
        });
    };
    var onCompletePostCode = function(postcode) {
        setPickAddress(postcode.address);
        setUserInputs(_objectSpread({}, userInputs, {
            addressLoad: postcode.roadAddress !== "" ? postcode.roadAddress : postcode.autoRoadAddress,
            addressJibun: postcode.jibunAddress !== "" ? postcode.jibunAddress : postcode.autoJibunAddress,
            addressCode: postcode.zonecode
        }));
        setIsOpen(false);
    };
    // 견적 선택
    var selectItem = function(i, el) {
        return function(e) {
            var tempArr = _toConsumableArray(selectedItem);
            tempArr[i] = e.target.checked;
            setSelectedItem(tempArr);
            if (e.target.checked) {
                var tempArr2 = _toConsumableArray(confirmItems);
                tempArr2[i] = el;
                setConfirmItems(tempArr2);
            } else {
                var tempArr21 = _toConsumableArray(confirmItems);
                tempArr21[i] = undefined;
                setConfirmItems(tempArr21);
            }
        };
    };
    // 견적 요청
    var confirmCustomizing = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee2() {
            var ref15, ref9, ref10, ref11, ref12, ref13, body;
            return runtime_default().wrap(function _callee$(_ctx2) {
                while(1)switch(_ctx2.prev = _ctx2.next){
                    case 0:
                        ;
                        if (!(printCartItems.filter(function(el) {
                            return el !== undefined;
                        }).length < 1)) {
                            _ctx2.next = 3;
                            break;
                        }
                        return _ctx2.abrupt("return", (0,common_alert/* failAlert */.qh)("\uC120\uD0DD\uD55C \uACAC\uC801\uC774 \uC5C6\uC2B5\uB2C8\uB2E4."));
                    case 3:
                        if (!(printCartItems.length === 0 || printCartItems == undefined)) {
                            _ctx2.next = 5;
                            break;
                        }
                        return _ctx2.abrupt("return", (0,common_alert/* failAlert */.qh)("\uC694\uCCAD\uD560 \uACAC\uC801\uC774 \uC5C6\uC2B5\uB2C8\uB2E4."));
                    case 5:
                        body = {
                            modes: "InsertSet",
                            usages: userInputs.productInfo ? userInputs.productInfo : "",
                            company: userInputs.company || (userCompany === null || userCompany === void 0 ? void 0 : userCompany.name),
                            name: userInputs.name || (userInfo === null || userInfo === void 0 ? void 0 : (ref15 = userInfo.Member) === null || ref15 === void 0 ? void 0 : ref15.name),
                            tel: userInputs.phone || (userInfo === null || userInfo === void 0 ? void 0 : (ref9 = userInfo.Member) === null || ref9 === void 0 ? void 0 : ref9.phone),
                            email: userInputs.email || (userInfo === null || userInfo === void 0 ? void 0 : (ref10 = userInfo.Member) === null || ref10 === void 0 ? void 0 : ref10.email),
                            zipcode: userInputs.addressCode || (userCompany === null || userCompany === void 0 ? void 0 : userCompany.zipcode),
                            doro_addr: userInputs.addressLoad || (userCompany === null || userCompany === void 0 ? void 0 : userCompany.doro_addr),
                            base_addr: userInputs.addressJibun || (userCompany === null || userCompany === void 0 ? void 0 : userCompany.base_addr),
                            detail_addr: userInputs.detail_addr || (userCompany === null || userCompany === void 0 ? void 0 : userCompany.detail_addr),
                            mapx: ((ref11 = userInputs.addressGps) === null || ref11 === void 0 ? void 0 : ref11.mapx) || (userCompany === null || userCompany === void 0 ? void 0 : userCompany.mapx),
                            mapy: ((ref12 = userInputs.addressGps) === null || ref12 === void 0 ? void 0 : ref12.mapy) || (userCompany === null || userCompany === void 0 ? void 0 : userCompany.mapy),
                            content: (userInputs === null || userInputs === void 0 ? void 0 : userInputs.content) ? userInputs.content : "",
                            files: infoFiles,
                            items: JSON.stringify(printCartItems.filter(function(el) {
                                return el !== undefined;
                            })),
                            editYn: userInputs.editYn || "TYPE0",
                            message: (userInputs.message || (userInfo === null || userInfo === void 0 ? void 0 : (ref13 = userInfo.Member) === null || ref13 === void 0 ? void 0 : ref13.message) || "").trim()
                        };
                        if (!(body.company === "" || body.company === undefined || body.name === "" || body.name === undefined || body.tel === "" || body.tel === undefined || body.email === "" || body.email === undefined)) {
                            _ctx2.next = 8;
                            break;
                        }
                        return _ctx2.abrupt("return", (0,common_alert/* failAlert */.qh)("\uB2F4\uB2F9\uC790 \uC815\uBCF4\uB97C \uC785\uB825\uD558\uC138\uC694."));
                    case 8:
                        if (!(body.zipcode === "" || body.zipcode === undefined || body.doro_addr === "" || body.doro_addr === undefined || body.detail_addr === "" || body.detail_addr === undefined)) {
                            _ctx2.next = 10;
                            break;
                        }
                        return _ctx2.abrupt("return", (0,common_alert/* failAlert */.qh)("\uBC30\uC1A1\uC9C0 \uC815\uBCF4\uB97C \uC785\uB825\uD558\uC138\uC694."));
                    case 10:
                        if (!(body.editYn !== "TYPE2" && body.files.length < 1)) {
                            _ctx2.next = 12;
                            break;
                        }
                        return _ctx2.abrupt("return", (0,common_alert/* failAlert */.qh)("\uB85C\uACE0 \uD639\uC740 \uB3C4\uC548\uD30C\uC77C\uC744 \uC5C5\uB85C\uB4DC\uD574\uC8FC\uC138\uC694."));
                    case 12:
                        _$modifyDefaultModal({
                            show: true,
                            actionBtnActive: true,
                            actionBtnLabel: "\uADF8\uB300\uB85C \uC8FC\uBB38\uD558\uAE30",
                            cancelBtnLabel: "\uB2E4\uC2DC \uB2F4\uC73C\uB7EC \uAC00\uAE30",
                            bodyContent: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "https://file.caretbio.com/caretbio/7410e4e7344808f189a38ee7240ced29.png",
                                        alt: "\uC18C\uB7C9\uC778\uC1C4 \uC548\uB0B4 \uC774\uBBF8\uC9C0",
                                        style: {
                                            maxWidth: "294px",
                                            marginBottom: "10px"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        style: {
                                            color: "#253d4e",
                                            fontSize: "18px"
                                        },
                                        children: "\uC18C\uB7C9\uC778\uC1C4\uB294 1,000\uC7A5\uC774 \uAC00\uC7A5 \uC800\uB834\uD569\uB2C8\uB2E4."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        style: {
                                            color: "#253d4e",
                                            fontSize: "18px"
                                        },
                                        children: "1,000\uC7A5 \uC778\uC1C4\uC2DC \uCD5C\uB300 78% \uD560\uC778\uC774 \uC801\uC6A9\uB429\uB2C8\uB2E4."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        style: {
                                            color: "#253d4e",
                                            fontSize: "15px",
                                            marginBottom: "20px"
                                        },
                                        children: "(100\uC7A5 \uB300\uBE44 / \uC7A5\uB2F9 \uAC00\uACA9 \uAE30\uC900)"
                                    })
                                ]
                            }),
                            onAction: _asyncToGenerator(runtime_default().mark(function _callee() {
                                var res, ref;
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            _$isLoading();
                                            _ctx.next = 3;
                                            return (0,smallPackaging/* smallPackagingAPI */.t)(body);
                                        case 3:
                                            res = _ctx.sent;
                                            if (res.Code === "0000") {
                                                setPrintCartItems([]);
                                                sessionStorage.setItem("printCart", JSON.stringify([]));
                                                _$isLoaded();
                                                router.push("/mypage/print");
                                            } else {
                                                ;
                                                _$isLoaded();
                                                (0,common_alert/* failAlert */.qh)(((ref = res.Data) === null || ref === void 0 ? void 0 : ref.Msg) || "\uACAC\uC801 \uC694\uCCAD \uC2E4\uD328");
                                            }
                                            _$closeDefaultModal();
                                        case 6:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            }))
                        });
                        _$openDefaultModal();
                    case 14:
                    case "end":
                        return _ctx2.stop();
                }
            }, _callee2);
        }));
        return function confirmCustomizing() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (isOpen) {
            globalThis.onkeydown = function(e) {
                if (e.code === "Escape") {
                    setIsOpen(false);
                }
            };
        }
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
                className: "row",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CartWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(CartTableWrapper, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                            children: "\uD488\uBA85"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                            children: "\uC218\uB7C9"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                            children: "\uCD1D \uC218\uB7C9"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                            children: "\uD310\uB9E4\uAC00"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                            children: "\uC778\uC1C4\uBE44"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                            children: "\uC0AD\uC81C"
                                                        })
                                                    ]
                                                })
                                            }),
                                            printCartItems && printCartItems.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                                                children: [
                                                    printCartItems === null || printCartItems === void 0 ? void 0 : printCartItems.map(function(el, i) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    className: "info",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                        href: "/products/".concat(el.ename, "/").concat(el.pcode, "/"),
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                            style: {
                                                                                display: "flex",
                                                                                alignItems: "center",
                                                                                gap: "10px"
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                    src: el.main_image,
                                                                                    alt: el.pname
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    children: el.pname
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    style: {
                                                                        width: "15%"
                                                                    },
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "d-flex align-items-center w-100",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                                className: "form-control text-center me-2",
                                                                                type: "number",
                                                                                min: 1,
                                                                                max: 1000,
                                                                                value: el.cnt || 1,
                                                                                onChange: function(e) {
                                                                                    return handleCnt(e, el.pcode);
                                                                                }
                                                                            }),
                                                                            "\uAC1C"
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                                                    children: [
                                                                        (0,splicePrice/* priceComma */.a)(Number(el.quantity) * Number(el.cnt)),
                                                                        "\uAC1C"
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: (0,splicePrice/* priceComma */.a)(Number(el.discount_price) * Number(el.cnt))
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    style: {
                                                                        whiteSpace: "nowrap"
                                                                    },
                                                                    children: "24\uC2DC\uAC04 \uC774\uB0B4 \uACAC\uC801"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                        className: "btn btn-sm btn-danger",
                                                                        onClick: function() {
                                                                            return deleteBasketItem(el.pcode);
                                                                        },
                                                                        children: "\uC0AD\uC81C"
                                                                    })
                                                                })
                                                            ]
                                                        }, i);
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            colSpan: 999,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlusIcon, {
                                                                onClick: function() {
                                                                    return moveToList();
                                                                },
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                    className: "fi-rs-plus"
                                                                })
                                                            })
                                                        })
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            colSpan: 999,
                                                            children: "\uB2F4\uAE34 \uC0C1\uD488\uC774 \uC5C6\uC2B5\uB2C8\uB2E4."
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            colSpan: 999,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlusIcon, {
                                                                onClick: function() {
                                                                    return moveToList();
                                                                },
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                    className: "fi-rs-plus"
                                                                })
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                printCartItems && /*#__PURE__*/ (0,jsx_runtime.jsxs)(MobileCartWrapper, {
                                    children: [
                                        printCartItems === null || printCartItems === void 0 ? void 0 : printCartItems.map(function(el, i) {
                                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(CartProductsMobile, {
                                                children: [
                                                    (printCartItems === null || printCartItems === void 0 ? void 0 : printCartItems.length) <= 0 && "\uACAC\uC801\uC774 \uC5C6\uC2B5\uB2C8\uB2E4",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "custome-checkbox me-3",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                type: "checkbox",
                                                                id: "".concat(el.id),
                                                                className: "form-check-input",
                                                                value: el.id ? el.id : "",
                                                                onChange: selectItem(i, el),
                                                                checked: selectedItem[i]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                className: "form-check-label d-flex",
                                                                htmlFor: "".concat(el.id),
                                                                style: {
                                                                    textTransform: "capitalize"
                                                                }
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductMobileImg, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: el.main_image,
                                                            alt: "",
                                                            className: "mr-10"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductMobileInfo, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                                children: el.pname
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "d-flex align-items-center",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            style: {
                                                                                width: "fit-content",
                                                                                whiteSpace: "nowrap"
                                                                            },
                                                                            className: "me-2",
                                                                            children: "\uC218\uB7C9 :"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                            className: "form-control w-100 text-center me-2",
                                                                            type: "number",
                                                                            min: 1,
                                                                            max: 1000,
                                                                            value: el.cnt || 1,
                                                                            onChange: function(e) {
                                                                                return handleCnt(e, el.pcode);
                                                                            },
                                                                            style: {
                                                                                height: "40px"
                                                                            }
                                                                        }),
                                                                        "\uAC1C"
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                children: [
                                                                    "\uBB36\uC74C\uC218\uB7C9 :",
                                                                    " ",
                                                                    (0,splicePrice/* priceComma */.a)(Number(el.quantity) * Number(el.cnt)),
                                                                    "\uAC1C"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                children: [
                                                                    "\uD310\uB9E4\uAC00 :",
                                                                    " ",
                                                                    (0,splicePrice/* priceComma */.a)(Number(el.discount_price) * Number(el.cnt)),
                                                                    "\uC6D0"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: "\uC778\uC1C4\uBE44 : 24\uC2DC\uAC04 \uC774\uB0B4 \uACAC\uC801"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "btn_wrapper",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                    className: "btn btn-sm btn-danger ml-10 mt-5",
                                                                    onClick: function() {
                                                                        return deleteBasketItem(el.pcode);
                                                                    },
                                                                    children: "\uC0AD\uC81C"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }, i);
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PlusIcon, {
                                            onClick: function() {
                                                return moveToList();
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                className: "fi-rs-plus"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoWrapper, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoBox, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "title",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h5", {
                                                        children: [
                                                            "\uC8FC\uBB38\uC778 \uC815\uBCF4",
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "input-option",
                                                                style: {
                                                                    color: "red"
                                                                },
                                                                children: "(\uD544\uC218)"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormInputRow, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInputBasicSpan, {
                                                            children: "\uC5C5\uCCB4\uBA85"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInputBasicInput, {
                                                            type: "text",
                                                            placeholder: "\uC5C5\uCCB4\uBA85",
                                                            onChange: onChangeUserInputs("company"),
                                                            defaultValue: (userCompany === null || userCompany === void 0 ? void 0 : userCompany.name) || ""
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormInputRow, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInputBasicSpan, {
                                                            children: "\uB2F4\uB2F9\uC790"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInputBasicInput, {
                                                            type: "text",
                                                            placeholder: "\uB2F4\uB2F9\uC790",
                                                            onChange: onChangeUserInputs("name"),
                                                            defaultValue: (userInfo === null || userInfo === void 0 ? void 0 : (ref14 = userInfo.Member) === null || ref14 === void 0 ? void 0 : ref14.name) || ""
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormInputRow, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInputBasicSpan, {
                                                            children: "\uB2F4\uB2F9\uC790 \uC5F0\uB77D\uCC98"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInputBasicInput, {
                                                            type: "text",
                                                            placeholder: "-\uB97C \uC81C\uC678\uD55C \uC22B\uC790\uB9CC",
                                                            onChange: onChangeUserInputs("phone"),
                                                            defaultValue: (userInfo === null || userInfo === void 0 ? void 0 : (ref1 = userInfo.Member) === null || ref1 === void 0 ? void 0 : ref1.phone) || "",
                                                            maxLength: 13
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormInputRow, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInputBasicSpan, {
                                                            children: "\uB2F4\uB2F9\uC790 \uC774\uBA54\uC77C"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInputBasicInput, {
                                                            type: "text",
                                                            placeholder: "\uC774\uBA54\uC77C",
                                                            onChange: onChangeUserInputs("email"),
                                                            defaultValue: (userInfo === null || userInfo === void 0 ? void 0 : (ref2 = userInfo.Member) === null || ref2 === void 0 ? void 0 : ref2.email) || ""
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "title mt-25",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h5", {
                                                        children: [
                                                            "\uBC30\uC1A1\uC9C0 \uC815\uBCF4",
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "input-option",
                                                                style: {
                                                                    color: "red"
                                                                },
                                                                children: "(\uD544\uC218)"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(AddressSearch, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInputBasicSpan, {
                                                            children: "\uC8FC\uC18C"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormBasicBtn, {
                                                                    type: "button",
                                                                    onClick: onClickHandleModal,
                                                                    children: "\uC8FC\uC18C\uAC80\uC0C9"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                    disabled: true,
                                                                    value: (userInputs === null || userInputs === void 0 ? void 0 : userInputs.addressCode) || (userCompany === null || userCompany === void 0 ? void 0 : userCompany.zipcode) || "",
                                                                    readOnly: true
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormInputRow, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInputBasicSpan, {}),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInputBasicInput, {
                                                            disabled: true,
                                                            address: true,
                                                            readOnly: true,
                                                            value: pickAddress || (userCompany === null || userCompany === void 0 ? void 0 : userCompany.doro_addr) || ""
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormInputRow, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInputBasicSpan, {}),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInputBasicInput, {
                                                            placeholder: "\uC0C1\uC138\uC8FC\uC18C \uC785\uB825",
                                                            address: true,
                                                            value: (userInputs === null || userInputs === void 0 ? void 0 : userInputs.detail_addr) || (userCompany === null || userCompany === void 0 ? void 0 : userCompany.detail_addr) || "",
                                                            onChange: onChangeUserInputs("detail_addr")
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "title mt-25",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                        children: "\uBC30\uC1A1 \uBA54\uC138\uC9C0"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                                                    placeholder: "\uBC30\uC1A1 \uC2DC \uC694\uCCAD\uD560 \uB0B4\uC6A9\uC744 \uC791\uC131\uD574\uC8FC\uC138\uC694.",
                                                    onChange: onChangeUserInputs("message")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoBox, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "title",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                        children: "\uD3EC\uC7A5 \uC0C1\uD488 \uC815\uBCF4"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormInputLargeRow, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormInputLargeSpan, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: "\uD3EC\uC7A5\uD558\uC2DC\uB294 \uC0C1\uD488 \uC815\uBCF4\uB97C \uBAA8\uB450 \uC785\uB825\uD574\uC8FC\uC138\uC694."
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "example",
                                                                    children: "\uC608\uC2DC) 4kg / \uD654\uC7A5\uD488"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInputBasicInput, {
                                                            placeholder: "\uC0C1\uD488 \uC815\uBCF4 \uC785\uB825",
                                                            full: true,
                                                            onChange: onChangeUserInputs("productInfo")
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormInputLargeRow, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormInputLargeSpan, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                    children: [
                                                                        "\uD30C\uC77C \uC5C5\uB85C\uB4DC",
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            className: "input-option",
                                                                            style: {
                                                                                color: "red"
                                                                            },
                                                                            children: "(\uD544\uC218)"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: "https://file.caretbio.com/caretbio/\u110F\u1161\u11AF\u1105\u1166\u11BA\u1109\u1173\u1110\u1169\u110B\u1165_\u1109\u1169\u1105\u1163\u11BC\u110B\u1175\u11AB\u1109\u116B_\u110F\u1161\u11AF\u1109\u1165\u11AB\u1100\u1161\u110B\u1175\u1103\u1173_240403153610.Zip",
                                                                        target: "__blank",
                                                                        className: "btn btn-small w-fit",
                                                                        children: "\uCE7C\uC120 \uB2E4\uC6B4\uB85C\uB4DC"
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FileUploadWrapper, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomFileInput/* default */.Z, {
                                                                handleFiles: onChangeFiles,
                                                                ment: ((userInputs === null || userInputs === void 0 ? void 0 : userInputs.editYn) === "TYPE0" || !(userInputs === null || userInputs === void 0 ? void 0 : userInputs.editYn)) && "\uCE7C\uC120 \uB3C4\uC548\uC744 \uC5C5\uB85C\uB4DC \uD574\uC8FC\uC138\uC694." || (userInputs === null || userInputs === void 0 ? void 0 : userInputs.editYn) === "TYPE1" && "\uB85C\uACE0\uB97C \uC5C5\uB85C\uB4DC \uD574\uC8FC\uC138\uC694." || (userInputs === null || userInputs === void 0 ? void 0 : userInputs.editYn) === "TYPE2" && ""
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "mt-10",
                                                            children: "* \uB85C\uACE0\uD30C\uC77C \uB610\uB294 \uB85C\uACE0\uAC00 \uBC30\uCE58\uB41C \uCE7C\uC120\uB3C4\uC548\uC744 \uC5C5\uB85C\uB4DC\uD574\uC8FC\uC138\uC694 (ai \uD30C\uC77C)"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: "* \uB85C\uACE0\uAC00 \uC900\uBE44\uB418\uC5B4 \uC788\uC9C0 \uC54A\uC740 \uACBD\uC6B0\uC5D0\uB294 \uAD00\uB828 \uC774\uBBF8\uC9C0\uB97C \uC5C5\uB85C\uB4DC\uD574\uC8FC\uC138\uC694 (\uD30C\uC77C \uD615\uC2DD \uBB34\uAD00)"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormInputLargeRow, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "title mt-25",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                children: "\uC120\uD0DD \uC0AC\uD56D"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormInputRow, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInputBasicSpan, {
                                                                    large: true,
                                                                    children: "\uB514\uC790\uC778 \uC791\uC5C5"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormInputBasicSelect, {
                                                                    address: true,
                                                                    value: (userInputs === null || userInputs === void 0 ? void 0 : userInputs.editYn) || "TYPE0",
                                                                    onChange: onChangeUserInputs("editYn"),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                            value: "TYPE0",
                                                                            children: "\uC120\uD0DD \uC548\uD568"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                            value: "TYPE1",
                                                                            children: "\uB3C4\uC548 \uCE7C\uC120\uBC30\uCE58"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                            value: "TYPE2",
                                                                            children: "\uB514\uC790\uC778 \uC11C\uBE44\uC2A4(\uBCC4\uB3C4 \uBE44\uC6A9 \uC0C1\uB2F4)"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: "* \uB85C\uACE0\uD30C\uC77C\uC774 \uC788\uC9C0\uB9CC \uC77C\uB7EC\uC2A4\uD2B8 \uC791\uC5C5\uC774 \uC5B4\uB824\uC6B0\uC2E0 \uCE7C\uC120\uB3C4\uC548 \uBC30\uCE58\uB97C \uC120\uD0DD\uD574\uC8FC\uC138\uC694."
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: "* \uB85C\uACE0\uD30C\uC77C\uC774 \uC5C6\uB294 \uACBD\uC6B0 \uB514\uC790\uC778 \uC11C\uBE44\uC2A4\uB97C \uC120\uD0DD\uD574\uC8FC\uC138\uC694."
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "d-flex justify-content-end mt-5",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "/customizing/design-service",
                                                                target: "__blank",
                                                                className: "btn btn-small w-fit",
                                                                children: "\uB514\uC790\uC778 \uC11C\uBE44\uC2A4 \uBCF4\uB7EC\uAC00\uAE30"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormInputLargeRow, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "title",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                children: "\uC694\uCCAD \uC0AC\uD56D "
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                                                            placeholder: "\uACAC\uC801\uC2DC \uC694\uCCAD\uD560 \uB0B4\uC6A9\uC744 \uC791\uC131\uD574\uC8FC\uC138\uC694.",
                                                            onChange: onChangeUserInputs("content")
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CartBtnWrapper, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        className: "btn btn-md",
                                        onClick: confirmCustomizing,
                                        children: [
                                            router.query.type === "direct" ? "" : "\uC120\uD0DD",
                                            " \uACAC\uC801 \uC694\uCCAD"
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            isOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(postcode/* default */.Z, {
                onClickHandleModal: onClickHandleModal,
                onCompletePostCode: onCompletePostCode
            }),
            pickAddress && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    display: "hidden"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Maptainer/* default */.Z, {
                    userInputs: userInputs,
                    setUserInputs: setUserInputs,
                    address: pickAddress
                })
            })
        ]
    });
};
var mapDispatchToProps = {
    openConfirmModal: action_confirm/* openConfirmModal */._5,
    modifyConfirmModal: action_confirm/* modifyConfirmModal */.sR,
    closeConfirmModal: action_confirm/* closeConfirmModal */.d6,
    isLoaded: loading/* isLoaded */.k,
    isLoading: loading/* isLoading */.h,
    closeDefaultModal: defaultModal/* closeDefaultModal */._i,
    modifyDefaultModal: defaultModal/* modifyDefaultModal */.kj,
    openDefaultModal: defaultModal/* openDefaultModal */.Rh
};
/* harmony default export */ var printCart_PrintCart = ((0,es/* connect */.$j)(null, mapDispatchToProps)(PrintCart));

// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/useQuery.js + 7 modules
var useQuery = __webpack_require__(87633);
// EXTERNAL MODULE: ./common/queryKeys.js
var queryKeys = __webpack_require__(51586);
// EXTERNAL MODULE: ./api/boards.js
var boards = __webpack_require__(67623);
;// CONCATENATED MODULE: ./hook/customizing/print/usePrintFaqQuery.js
function usePrintFaqQuery_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function usePrintFaqQuery_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                usePrintFaqQuery_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                usePrintFaqQuery_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}




var usePrintFaqQuery = function() {
    return (0,useQuery/* useQuery */.a)({
        queryKey: queryKeys/* QUERY_KEYS.CUSTOMIZING.PRINT.FAQ */.U.CUSTOMIZING.PRINT.FAQ,
        queryFn: usePrintFaqQuery_asyncToGenerator(runtime_default().mark(function _callee() {
            var body, res;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        body = {
                            modes: "List",
                            boardName: "sfaq"
                        };
                        _ctx.next = 3;
                        return (0,boards/* fetchBoards */.P)(body);
                    case 3:
                        res = _ctx.sent;
                        if (!(res.Code === "0000" || res.code === "0000")) {
                            _ctx.next = 8;
                            break;
                        }
                        return _ctx.abrupt("return", res.data.data);
                    case 8:
                        return _ctx.abrupt("return", []);
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        })),
        retry: 1
    });
};

// EXTERNAL MODULE: ./components/csboard/faq/faq-styles.js
var faq_styles = __webpack_require__(56516);
;// CONCATENATED MODULE: ./hook/customizing/print/useTabStickyHandler.js

var useTabStickyHandler = function(ref) {
    var ref1 = (0,react.useState)(false), isSticky = ref1[0], setIsSticky = ref1[1];
    (0,react.useEffect)(function() {
        var handleScroll = function() {
            // 카테고리 섹션 아래의 위치를 기준점으로 설정 (약 280px 정도로 예상)
            var stickyThreshold = 280;
            if (window.scrollY > stickyThreshold) {
                setIsSticky(true);
            } else {
                setIsSticky(false);
            }
        };
        window.addEventListener("scroll", handleScroll);
        return function() {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    return {
        isSticky: isSticky
    };
};

;// CONCATENATED MODULE: ./components/customizing/print/Print.presenter.js












var PrintPageUI = function(props) {
    var ref;
    var onClickInquiry = props.onClickInquiry, listRef = props.listRef, cartRef = props.cartRef, productList = props.productList, addPrintCart = props.addPrintCart, inCart = props.inCart, userInfo = props.userInfo, userCompany = props.userCompany, printCartItems = props.printCartItems, setPrintCartItems = props.setPrintCartItems;
    var observers = Array.from({
        length: 10
    }, function(_, index) {
        return (0,dist/* useInView */.YD)({
            threshold: 0.1
        });
    });
    var router = (0,next_router.useRouter)();
    var tabHeaderRef = (0,react.useRef)(null);
    var isSticky = useTabStickyHandler(tabHeaderRef).isSticky; // 탭 헤더 sticky 상태 관리
    var ref1 = (0,react.useState)(0), activeComponent = ref1[0], setActiveComponent = ref1[1];
    var ref2 = (0,react.useState)(0), activeTab = ref2[0], setActiveTab = ref2[1]; // 사이즈 탭
    var ref3 = (0,react.useState)(0), activeMainTab = ref3[0], setActiveMainTab = ref3[1]; // 메인 탭 (0: 재질, 1: 가이드 및 필수사항, 2: 견적 및 구매)
    var ref4 = (0,react.useState)(""), isActive = ref4[0], setIsActive = ref4[1]; //faq
    var ref5 = usePrintFaqQuery(), faqList = ref5.data, isLoading = ref5.isLoading, error = ref5.error; //faq 리스트
    // 리스트로 이동시키기
    var moveToList = function() {
        window.scrollTo({
            behavior: "smooth",
            left: 0,
            top: listRef.current.offsetTop
        });
    };
    (0,react.useEffect)(function() {
        // URL 쿼리 파라미터에서 tab 값을 확인
        if (router.isReady && router.query.tab === "product") {
            // 상품 • 견적 탭 인덱스로 설정 (FAQ 유무에 따라 5 또는 6)
            var productTabIndex = faqList && faqList.length > 0 ? 6 : 5;
            onChangeMainTab(productTabIndex);
            // 상품 목록 위치로 스크롤 (필요한 경우)
            if (listRef.current) {
                setTimeout(function() {
                    window.scrollTo({
                        behavior: "smooth",
                        top: listRef.current.offsetTop
                    });
                }, 100);
            }
        }
    }, [
        router.isReady,
        router.query,
        faqList
    ]);
    (0,react.useEffect)(function() {
        var inViews = observers.map(function(el) {
            return el.inView;
        });
        if (!inViews.includes(true)) {
            if (activeComponent === 3 || activeComponent === 4) {
                setActiveComponent(4);
                return;
            }
            setActiveComponent(0);
            return;
        }
        inViews.forEach(function(el, i) {
            if (el === true) {
                if (i === 0) {
                    setActiveComponent(i);
                } else if (inViews[i - 1] === true) {
                    setActiveComponent(i - 1);
                } else {
                    setActiveComponent(i);
                }
            }
        });
    }, [
        observers
    ]);
    var shouldShowTabContent = function(tabIndex) {
        // FAQ 탭(5)인 경우
        if (tabIndex === 5) {
            return faqList && faqList.length > 0 && activeMainTab === 5;
        }
        // 상품 구매 탭인 경우
        if (tabIndex === 6) {
            // FAQ가 없으면 5번, 있으면 6번
            return (!faqList || faqList.length === 0) && activeMainTab === 5 || faqList && faqList.length > 0 && activeMainTab === 6;
        }
        // 다른 탭들
        return activeMainTab === tabIndex;
    };
    // 메인 탭 변경 함수
    var onChangeMainTab = function(tabIndex) {
        // 탭 상태 업데이트
        setActiveMainTab(tabIndex);
        // 페이지 상단으로 스크롤
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    var onClickOpenFAQ = function(i) {
        return function() {
            if (isActive !== i) setIsActive(i);
            if (isActive === i) setIsActive("");
        };
    };
    var tabs = faqList && faqList.length === 0 ? defaultTabs.filter(function(tab) {
        return tab.label !== "FAQ";
    }) : defaultTabs;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabContainer, {
                ref: tabHeaderRef,
                isSticky: isSticky,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TabHeader, {
                    children: tabs.map(function(tab, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TabItem, {
                            active: activeMainTab === index,
                            onClick: function() {
                                return onChangeMainTab(index);
                            },
                            children: tab.label
                        }, index);
                    })
                })
            }),
            activeMainTab === 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "container",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(NormalTitle, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "\uC18C\uB7C9\uC778\uC1C4"
                                    }),
                                    " \uC11C\uBE44\uC2A4 \uC18C\uAC1C"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StrengthWarpper, {
                                children: strengthArr.map(function(st, idx) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StrengthBox, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: st.img,
                                                alt: st.img
                                            }),
                                            st.desc.map(function(el, i) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: el
                                                }, i);
                                            })
                                        ]
                                    }, idx);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StrengthSliderWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "strengthSection",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StrengthPC, {
                                    className: "container",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h6", {
                                            children: [
                                                "\uCE7C\uB81B\uC2A4\uD1A0\uC5B4\uC758 ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                    children: "\uC18C\uB7C9\uC778\uC1C4"
                                                }),
                                                "\uAC00 \uD2B9\uBCC4\uD55C \uC774\uC720!"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "strengthGrid",
                                            children: strengthSlideArr.map(function(str, idx) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "content",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: str.img
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "desc",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                                    children: str.title
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: str.desc
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }, idx);
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "container swiperSection",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                                        navigation: {
                                            prevEl: ".custom_prev_i1",
                                            nextEl: ".custom_next_i1"
                                        },
                                        pagination: {
                                            clickable: true,
                                            el: ".swiper-pagination"
                                        },
                                        children: strengthSlideArr.map(function(str, idx) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StrengthSlide, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h6", {
                                                            children: [
                                                                "\uCE7C\uB81B\uC2A4\uD1A0\uC5B4\uC758 ",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                    children: "\uC18C\uB7C9\uC778\uC1C4"
                                                                }),
                                                                "\uAC00 \uD2B9\uBCC4\uD55C \uC774\uC720!"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "content",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    src: str.img
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "desc",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                                            children: str.title
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            children: str.desc
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }, idx);
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "slider-arrow",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "slider-btn slider-prev slick-arrow custom_prev_i1",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                    className: "fi-rs-angle-left"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "slider-btn slider-next slick-arrow custom_next_i1",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                    className: "fi-rs-angle-right"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "swiper-pagination"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            activeMainTab === 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DesignGuide, {
                    className: "container",
                    id: "guide",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "d-flex flex-column mb-50 pb-80 border-bottom",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(NormalTitle, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            children: "\uCE5C\uC808\uD55C \uAC00\uC774\uB4DC"
                                        }),
                                        "\uB85C \uC27D\uACE0, \uD3B8\uD558\uAC8C!"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(TitleDesc, {
                                    children: [
                                        "\uC608\uC2DC \uC0AC\uC774\uC988(450mm x 580mm + 40mm)\uC640",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            className: "",
                                            children: "\uB3D9\uC77C\uD55C \uADDC\uCE59"
                                        }),
                                        "\uC73C\uB85C",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            className: "ms-1",
                                            children: "\uB2E4\uB978 \uC0AC\uC774\uC988\uC5D0\uB3C4 \uC801\uC6A9"
                                        }),
                                        "\uB418\uB2C8 \uCC38\uACE0\uD574 \uC8FC\uC138\uC694."
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ImgGuideWrapper, {
                                    className: "mt-30 mb-30",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "/assets/imgs/print/design_guide/\uB514\uC790\uC778 \uC0AC\uC774\uB4DC 1.png"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "description",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "title",
                                                    children: "\uC55E\uBA74 \uC791\uC5C5 \uC601\uC5ED (450mm x 580mm + 40mm)"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "desc mb-50",
                                                    children: "\uAE30\uBCF8\uC73C\uB85C \uC778\uC1C4\uB418\uC5B4 \uC788\uB294 \uD658\uACBD\uC778\uC99D\uB9C8\uD06C\uC640 \uBB38\uAD6C\uC601\uC5ED\uACFC 40mm\uC601\uC5ED\uC744 \uC81C\uC678\uD55C \uC601\uC5ED\uC5D0 \uC778\uC1C4\uAC00\uB2A5\uD569\uB2C8\uB2E4."
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "title",
                                                    children: "\uB4B7\uBA74 \uC791\uC5C5 \uC601\uC5ED (450mm x 580mm) "
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "desc mb-50",
                                                    children: "40mm \uC601\uC5ED\uC744 \uC81C\uC678\uD55C \uBAA8\uB4E0 \uC601\uC5ED\uC5D0 \uC778\uC1C4\uAC00\uB2A5\uD569\uB2C8\uB2E4."
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: "danger",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                            className: "fi-rs-exclamation"
                                                        }),
                                                        "\uC81C\uACF5\uB41C \uCE7C\uC120\uB3C4\uC548\uC740 \uC2E4\uCE21 \uC0AC\uC774\uC988\uB85C \uCE21\uC815\uB3FC\uC788\uC73C\uB2C8 \uC218\uC815\uD558\uC9C0 \uB9D0\uC544\uC8FC\uC138\uC694."
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(DesignGuideDownloadWrapper, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "ment",
                                            children: "\uB514\uC790\uC778 \uAC00\uC774\uB4DC\uB97C \uB2E4\uC6B4\uB85C\uB4DC\uD558\uC5EC \uB098\uB9CC\uC758 \uB514\uC790\uC778\uC744 \uB9CC\uB4E4\uC5B4 \uBCF4\uC138\uC694."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                            href: "https://file.caretbio.com/caretbio/\u110F\u1161\u11AF\u1105\u1166\u11BA\u1109\u1173\u1110\u1169\u110B\u1165_\u1109\u1169\u1105\u1163\u11BC\u110B\u1175\u11AB\u1109\u116B_\u110F\u1161\u11AF\u1109\u1165\u11AB\u1100\u1161\u110B\u1175\u1103\u1173_240403153610.Zip",
                                            target: "__blank",
                                            className: "downloadBtn",
                                            children: [
                                                "AI ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                    className: "fi-rs-download"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "d-flex flex-column mb-50 pb-80 border-bottom",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NumberUnderBarTitle, {
                                    children: "01"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MediumTitle, {
                                    children: "\uC791\uC5C5\uBB3C \uC724\uACFD\uCC98\uB9AC"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ImgGridWrapper, {
                                    length: 2,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ImgBox, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "/assets/imgs/print/design_guide/\uB514\uC790\uC778_\uAC00\uC774\uB4DC_1-1.jpg"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    children: [
                                                        "\uD14D\uC2A4\uD2B8\uB098 \uB3C4\uD615\uC73C\uB85C \uC81C\uC791\uD55C \uC791\uC5C5\uBB3C\uC740",
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                            children: "Type > Create Outlines [Shift+Ctrl+O]"
                                                        }),
                                                        "\uB97C \uC0AC\uC6A9\uD558\uC5EC \uC724\uACFD\uCC98\uB9AC\uD574 \uC8FC\uC138\uC694."
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ImgBox, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "/assets/imgs/print/design_guide/\uB514\uC790\uC778_\uAC00\uC774\uB4DC_1-2.jpg"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    children: [
                                                        "\uD39C\uD234\uC744 \uC0AC\uC6A9\uD55C \uB77C\uC778\uD615\uD0DC\uC758 \uC791\uC5C5\uBB3C\uC740",
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                            children: "Object > Path > Outline Stroke"
                                                        }),
                                                        "\uC744 \uC0AC\uC6A9\uD558\uC5EC \uC724\uACFD\uCC98\uB9AC\uD574 \uC8FC\uC138\uC694."
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "d-flex flex-column mb-50 pb-80",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NumberUnderBarTitle, {
                                    children: "02"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MediumTitle, {
                                    children: "\uB808\uC774\uC5B4 \uAE30\uB2A5 \uC0AC\uC6A9"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ImgGridWrapper, {
                                    length: 2,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ImgBox, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "/assets/imgs/print/design_guide/\uB514\uC790\uC778_\uAC00\uC774\uB4DC_2-1.jpg"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                            children: "'\uB514\uC790\uC778'"
                                                        }),
                                                        " \uB808\uC774\uC5B4\uB97C \uC120\uD0DD\uD558\uACE0 \uB514\uC790\uC778\uC774 \uC644\uB8CC\uB41C \uC791\uC5C5\uBB3C\uC744 \uBC30\uCE58\uD574 \uC8FC\uC138\uC694."
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ImgBox, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "/assets/imgs/print/design_guide/\uB514\uC790\uC778_\uAC00\uC774\uB4DC_2-2.jpg"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    children: [
                                                        "\uB808\uC774\uC5B4 \uC21C\uC11C\uB294 \uAC00\uC774\uB4DC \uD30C\uC77C \uADF8\uB300\uB85C \uBCC0\uACBD\uC5C6\uC774 \uC791\uC5C5\uD574\uC57C \uD558\uBA70,",
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                            children: "\uB808\uC774\uC5B4\uBA85 \uBCC0\uACBD \uBC0F \uB808\uC774\uC5B4 \uCD94\uAC00\uB3C4 \uBD88\uAC00"
                                                        }),
                                                        "\uD569\uB2C8\uB2E4."
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            activeMainTab === 2 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductInfoFeature, {
                className: "container",
                id: "feature",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "d-flex flex-column mb-50 pb-80 border-bottom",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "d-flex flex-column mb-50",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(NormalTitle, {
                                        children: [
                                            "\uCE7C\uB81B\uC2A4\uD1A0\uC5B4\uC758",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                children: " \uD2B9\uBCC4\uD55C \uC7AC\uC9C8"
                                            }),
                                            "\uC744 \uD655\uC778\uD574 \uBCF4\uC138\uC694."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NumberUnderBarTitle, {
                                        children: "01"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MediumTitle, {
                                        children: "EL606 \uD0DD\uBC30\uBD09\uD22C"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleDesc, {
                                        children: "\uD0C4\uC18C \uC800\uAC10\uC5D0 \uB3C4\uC6C0\uC744 \uC8FC\uB294 \uC7AC\uC0DD\uBE44\uB2D0 \uCE5C\uD658\uACBD \uD0DD\uBC30\uBD09\uD22C\uC785\uB2C8\uB2E4."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ImgGridWrapper, {
                                        length: 2,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ImgBox, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: "/assets/imgs/print/info_feature/\uC0C1\uD488\uC18C\uAC1C_\uC7AC\uC9C8_EL606\uD0DD\uBC30\uBD09\uD22C_1.jpg"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "\uC778\uC7A5\uB825\uACFC \uC0AC\uC774\uB4DC \uC2E4\uB9C1\uC774 \uD2BC\uD2BC\uD558\uC5EC \uB192\uC740 \uB0B4\uAD6C\uC131\uC744 \uBCF4\uC785\uB2C8\uB2E4."
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ImgBox, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: "/assets/imgs/print/info_feature/\uC0C1\uD488\uC18C\uAC1C_\uC7AC\uC9C8_EL606\uD0DD\uBC30\uBD09\uD22C_2.jpg"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "\uD658\uACBD\uD45C\uC9C0 \uC778\uC99D \uBC1B\uC740 \uC7AC\uC0DD\uD50C\uB77C\uC2A4\uD2F1 PCR(EL606) \uC218\uC9C0\uB97C 50% \uC774\uC0C1 \uD65C\uC6A9\uD574, \uD0C4\uC18C\uBC30\uCD9C\uB7C9 \uC800\uAC10\uACFC \uC790\uC6D0\uC120\uC21C\uD658\uC5D0 \uAE30\uC5EC\uD569\uB2C8\uB2E4."
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "d-flex flex-column mb-50",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NormalTitle, {
                                        children: "EL606 \uD0DD\uBC30\uBD09\uD22C \uC0C9\uC0C1\uC744 \uD655\uC778\uD574 \uBCF4\uC138\uC694."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SmallImgGridWrapper, {
                                        length: 2,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SmallImgBox, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: "/assets/imgs/print/info_feature/\uC0C1\uD488\uC18C\uAC1C_\uC7AC\uC9C8_EL606\uD0DD\uBC30\uBD09\uD22C_\uD551\uD06C.jpg"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "\uC778\uB514\uD551\uD06C "
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SmallImgBox, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: "/assets/imgs/print/info_feature/\uC0C1\uD488\uC18C\uAC1C_\uC7AC\uC9C8_EL606\uD0DD\uBC30\uBD09\uD22C_\uB124\uC628.jpg"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "\uB124\uC628"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "d-flex flex-column mb-50 pb-80 border-bottom",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "d-flex flex-column mb-50",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NumberUnderBarTitle, {
                                        children: "02"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MediumTitle, {
                                        children: "EL727 \uD0DD\uBC30\uBD09\uD22C"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleDesc, {
                                        children: "\uD0C4\uC18C \uC800\uAC10\uC5D0 \uB3C4\uC6C0\uC744 \uC8FC\uB294 \uBC14\uC774\uC624\uB9E4\uC2A4 \uD0DD\uBC30\uBD09\uD22C\uC785\uB2C8\uB2E4."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ImgGridWrapper, {
                                        length: 2,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ImgBox, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: "/assets/imgs/print/info_feature/\uC0C1\uD488\uC18C\uAC1C_\uC7AC\uC9C8_EL727\uD0DD\uBC30\uBD09\uD22C_1.jpg"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "\uB0B4\uAD6C\uC131\uC774 \uC6B0\uC218\uD558\uACE0 \uC774\uC911\uD569\uC9C0\uB85C \uC9C8\uAE30\uACE0 \uD2BC\uD2BC\uD558\uAC8C \uC81C\uC791\uB418\uC5C8\uC2B5\uB2C8\uB2E4."
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ImgBox, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: "/assets/imgs/print/info_feature/\uC0C1\uD488\uC18C\uAC1C_\uC7AC\uC9C8_EL727\uD0DD\uBC30\uBD09\uD22C_2.jpg"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "\uBC14\uC774\uC624\uB9E4\uC2A4 \uC18C\uC7AC \uC778\uC99D\uC744 \uBC1B\uC544 \uD0C4\uC18C\uC800\uAC10\uC5D0 \uD6A8\uACFC\uAC00 \uC788\uC2B5\uB2C8\uB2E4."
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "d-flex flex-column mb-50",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NormalTitle, {
                                        children: "EL727 \uD0DD\uBC30\uBD09\uD22C \uC0C9\uC0C1\uC744 \uD655\uC778\uD574 \uBCF4\uC138\uC694."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SmallImgGridWrapper, {
                                        length: 2,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SmallImgBox, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: "/assets/imgs/print/info_feature/\uC0C1\uD488\uC18C\uAC1C_\uC7AC\uC9C8_EL727\uD0DD\uBC30\uBD09\uD22C_\uD06C\uB9BC.jpg"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "\uD06C\uB9BC"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SmallImgBox, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: "/assets/imgs/print/info_feature/\uC0C1\uD488\uC18C\uAC1C_\uC7AC\uC9C8_EL727\uD0DD\uBC30\uBD09\uD22C_\uBE14\uB799.jpg"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "\uBE14\uB799"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "d-flex flex-column mb-0 pb-80",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "d-flex flex-column mb-50",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NumberUnderBarTitle, {
                                        children: "03"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MediumTitle, {
                                        children: "EL727 \uC18D\uBE44\uB2D0\uBD09\uD22C"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleDesc, {
                                        children: "\uD0C4\uC18C \uC800\uAC10\uC5D0 \uB3C4\uC6C0\uC744 \uC8FC\uB294 \uCE5C\uD658\uACBD \uBC14\uC774\uC624\uB9E4\uC2A4 \uC18D\uBE44\uB2D0\uBD09\uD22C\uC785\uB2C8\uB2E4."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ImgGridWrapper, {
                                        length: 2,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ImgBox, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: "/assets/imgs/print/info_feature/\uC0C1\uD488\uC18C\uAC1C_\uC7AC\uC9C8_EL727\uC18D\uBE44\uB2D0\uBD09\uD22C_1.jpg"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "\uB0B4\uAD6C\uC131\uC774 \uC6B0\uC218\uD558\uACE0 \uC774\uC911\uD569\uC9C0\uB85C \uC9C8\uAE30\uACE0 \uD2BC\uD2BC\uD558\uAC8C \uC81C\uC791\uB418\uC5C8\uC2B5\uB2C8\uB2E4."
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ImgBox, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: "/assets/imgs/print/info_feature/\uC0C1\uD488\uC18C\uAC1C_\uC7AC\uC9C8_EL727\uC18D\uBE44\uB2D0\uBD09\uD22C_2.jpg"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "\uBC14\uC774\uC624\uB9E4\uC2A4 \uC18C\uC7AC \uC778\uC99D\uC744 \uBC1B\uC544 \uD0C4\uC18C\uC800\uAC10\uC5D0 \uD6A8\uACFC\uAC00 \uC788\uC2B5\uB2C8\uB2E4."
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "d-flex flex-column mb-50",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NormalTitle, {
                                        children: "EL727 \uC18D\uBE44\uB2D0\uBD09\uD22C \uC0C9\uC0C1\uC744 \uD655\uC778\uD574 \uBCF4\uC138\uC694."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SmallImgGridWrapper, {
                                        length: 1,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SmallImgBox, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "/assets/imgs/print/info_feature/\uC0C1\uD488\uC18C\uAC1C_\uC7AC\uC9C8_EL727\uC18D\uBE44\uB2D0\uBD09\uD22C_\uBC18\uD22C\uBA85.jpg"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "\uBC18\uD22C\uBA85 "
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            activeMainTab === 3 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductInfoSize, {
                className: "container",
                id: "size",
                ref: observers[1].ref,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(NormalTitle, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: "\uD544\uC694\uD558\uC2E0 \uC0AC\uC774\uC988"
                            }),
                            "\uC5D0 \uB9DE\uAC8C \uC120\uD0DD\uD558\uC138\uC694."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SizeTabWrapper, {
                        children: [
                            Object.keys(SizeData).map(function(el, i) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(SizeTab, {
                                    active: i === activeTab,
                                    onClick: function() {
                                        return setActiveTab(i);
                                    },
                                    children: el
                                }, i);
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SizeSelect, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                                    className: "form-select",
                                    value: activeTab,
                                    onChange: function(e) {
                                        return setActiveTab(e.target.value);
                                    },
                                    children: Object.keys(SizeData).map(function(el, i) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                            value: i,
                                            children: el
                                        }, i);
                                    })
                                })
                            })
                        ]
                    }),
                    Object.values(SizeData)[activeTab].map(function(el, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductSizeBox, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BoldSmallTitle, {
                                    children: el.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NormalTitle, {
                                    children: el.size
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleDesc, {
                                    children: el.desc
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgGridWrapper, {
                                    length: el.imgs.length,
                                    children: el.imgs.map(function(img, imgIdx) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ImgBox, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: img.url
                                                }),
                                                img.desc && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: img.desc
                                                })
                                            ]
                                        }, imgIdx);
                                    })
                                })
                            ]
                        }, i);
                    })
                ]
            }),
            activeMainTab === 4 && /*#__PURE__*/ (0,jsx_runtime.jsx)(DesignGuide, {
                className: "",
                id: "essential",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container mb-50",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "d-flex flex-column",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(NormalTitle, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "\uB514\uC790\uC778 \uC81C\uC791\uC694\uCCAD \uC0AC\uD56D"
                                    }),
                                    " \uD544\uC218\uAE30\uC7AC!"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ImgGridWrapper, {
                                length: 2,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ImgBox, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/assets/imgs/print/design_essential/\uB514\uC790\uC778_\uD544\uC218\uC0AC\uD56D1.jpg"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                children: [
                                                    "\uD654\uC774\uD2B8 / \uBE14\uB799 \uC774\uC678\uC5D0 \uCEEC\uB7EC\uB294 ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                        children: "\uD32C\uD1A4\uCEEC\uB7EC\uB97C \uAE30\uC7AC"
                                                    }),
                                                    "\uD574 \uC8FC\uC138\uC694."
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ImgBox, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/assets/imgs/print/design_essential/\uB514\uC790\uC778_\uD544\uC218\uC0AC\uD56D2.jpg"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                children: [
                                                    "\uD0DD\uBC30\uBD09\uD22C\uC758 \uBC11\uB2E8\uBD80\uD130 \uC791\uC5C5\uD558\uC2E0 \uC791\uC5C5\uBB3C \uBC11\uB2E8\uAE4C\uC9C0",
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                        children: "mm\uB85C \uCE21\uC815\uD558\uC5EC \uAE30\uC7AC"
                                                    }),
                                                    "\uD574 \uC8FC\uC138\uC694."
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            shouldShowTabContent(5) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container mb-50",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(NormalTitle, {
                        children: [
                            "\uC18C\uB7C9\uC778\uC1C4 ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: "FAQ"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(faq_styles/* TableWrapper */.y6, {
                        children: faqList.map(function(el, i) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(faq_styles/* TableRow */.SC, {
                                onClick: onClickOpenFAQ(i),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(faq_styles/* FAQTop */.UZ, {
                                        isActive: isActive === i,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(faq_styles/* FAQTitle */.l5, {
                                                children: [
                                                    el.category,
                                                    el.title
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                className: isActive === i ? "fi-rs-angle-small-up" : "fi-rs-angle-small-down"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(faq_styles/* FAQContent */.C9, {
                                        isActive: isActive === i,
                                        dangerouslySetInnerHTML: {
                                            __html: el.contents
                                        }
                                    })
                                ]
                            }, i);
                        })
                    })
                ]
            }),
            shouldShowTabContent(6) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(NormalTitle, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: "\uC0C1\uD488 \uBC0F \uACAC\uC801"
                            }),
                            "\uC744 \uD55C \uBC88\uC5D0 \uC9C4\uD589\uD558\uC138\uC694."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container",
                        ref: listRef,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterList/* default */.Z, {
                            productList: productList,
                            addCart: addPrintCart,
                            inCart: inCart
                        })
                    }),
                    (userInfo === null || userInfo === void 0 ? void 0 : (ref = userInfo.Member) === null || ref === void 0 ? void 0 : ref.ukey) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container",
                        ref: cartRef,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(printCart_PrintCart, {
                            userInfo: userInfo,
                            userCompany: userCompany,
                            printCartItems: printCartItems,
                            setPrintCartItems: setPrintCartItems,
                            moveToList: moveToList
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "d-flex justify-content-center align-items-center pt-50 pb-50",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h6", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "/login",
                                        children: "\uB85C\uADF8\uC778"
                                    }),
                                    " \uD6C4 \uC774\uC6A9\uAC00\uB2A5\uD55C \uC11C\uBE44\uC2A4 \uC785\uB2C8\uB2E4."
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DesignBanner, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "content container-lg",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "textContent",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "\uB85C\uACE0\uAC00 \uC5C6\uB2E4\uBA74?"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                    children: "\uCE7C\uB81B\uC2A4\uD1A0\uC5B4 \uB514\uC790\uC778 \uC11C\uBE44\uC2A4\uB97C \uC774\uC6A9\uD574\uBCF4\uC138\uC694"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    children: [
                                        "\uAC04\uB2E8\uD55C \uB85C\uACE0 \uBC30\uCE58\uBD80\uD130 \uBE0C\uB79C\uB4DC \uB514\uC790\uC778\uAE4C\uC9C0! ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        " \uAC00\uACA9\uBCC4\uB85C \uB098\uC5D0\uAC8C \uB9DE\uB294 \uB514\uC790\uC778 \uC11C\uBE44\uC2A4\uB97C \uC774\uC6A9\uD574\uBCF4\uC138\uC694"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "https://file.caretbio.com/caretbio/9ac7d2c8185a56a72ecf459b2021022a.png",
                                    className: "m_banner"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "",
                                    href: "/customizing/design-service/",
                                    children: "\uC11C\uBE44\uC2A4 \uBCF4\uB7EC\uAC00\uAE30"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "https://file.caretbio.com/caretbio/47ffdb3584f54f4251b1c79b3aad90c1.png",
                            className: "pc_banner"
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var Print_presenter = (PrintPageUI);
var defaultTabs = [
    {
        label: "\uC0C1\uD488\uC18C\uAC1C"
    },
    {
        label: "\uAC00\uC774\uB4DC"
    },
    {
        label: "\uC7AC\uC9C8"
    },
    {
        label: "\uC0AC\uC774\uC988"
    },
    {
        label: "\uD544\uC218\uC0AC\uD56D"
    },
    {
        label: "FAQ"
    },
    {
        label: "\uC0C1\uD488 \u2022 \uACAC\uC801"
    }, 
];

// EXTERNAL MODULE: ./common/auth.js + 4 modules
var auth = __webpack_require__(48106);
;// CONCATENATED MODULE: ./components/customizing/print/Print.ProductsList.js
function Print_ProductsList_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function Print_ProductsList_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return Print_ProductsList_arrayLikeToArray(arr);
}
function Print_ProductsList_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function Print_ProductsList_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Print_ProductsList_toConsumableArray(arr) {
    return Print_ProductsList_arrayWithoutHoles(arr) || Print_ProductsList_iterableToArray(arr) || Print_ProductsList_unsupportedIterableToArray(arr) || Print_ProductsList_nonIterableSpread();
}
function Print_ProductsList_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return Print_ProductsList_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Print_ProductsList_arrayLikeToArray(o, minLen);
}












var PrintProductsList = function(param) {
    var productList = param.productList, printCartItems = param.printCartItems, dummyList = param.dummyList, listModal = param.listModal, handleListModal = param.handleListModal, _$closeConfirmModal = param.closeConfirmModal, _$modifyConfirmModal = param.modifyConfirmModal, _$openConfirmModal = param.openConfirmModal, addPrintCart = param.addPrintCart;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)([]), confirmItems = ref[0], setConfirmItems = ref[1];
    var ref1 = (0,react.useState)([]), selectedItem = ref1[0], setSelectedItem = ref1[1];
    // 상품 체크
    var selectItem = function(e, el, i) {
        var tempArr = Print_ProductsList_toConsumableArray(selectedItem);
        tempArr[i] = e.target.checked;
        setSelectedItem(tempArr);
        if (e.target.checked) {
            var tempArr2 = [
                el
            ].concat(Print_ProductsList_toConsumableArray(confirmItems));
            setConfirmItems(tempArr2);
        } else {
            var tempArr21 = Print_ProductsList_toConsumableArray(confirmItems);
            var index = tempArr21.findIndex(function(product) {
                return product.pcode === el.pcode;
            });
            tempArr21.splice(index, 1);
            setConfirmItems(tempArr21);
        }
    };
    // 전체 선택
    var selectAllItems = function(e) {
        if (e.target.checked) {
            var tempArr = new Array(productList.length).fill(true);
            setSelectedItem(tempArr);
            setConfirmItems(productList);
        } else {
            var tempArr2 = new Array(productList.length).fill(false);
            setSelectedItem(tempArr2);
            setConfirmItems([]);
        }
    };
    // 전체삭제
    var deleteAll = function() {
        var content = {
            title: "\uC804\uBD80 \uC0AD\uC81C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
            actionBtnLabel: "\uD655\uC778",
            actionBtnValid: true,
            cancelBtnLabel: "\uCDE8\uC18C",
            onAction: function() {
                setConfirmItems([]);
                setSelectedItem([]);
                successAlert("\uC7A5\uBC14\uAD6C\uB2C8 \uC804\uCCB4 \uC0AD\uC81C \uC644\uB8CC");
                _$closeConfirmModal();
            }
        };
        _$modifyConfirmModal(content);
        _$openConfirmModal();
    };
    (0,react.useEffect)(function() {
        if (!listModal) return;
        var tempArr2 = new Array(productList.length).fill(false);
        setSelectedItem(tempArr2);
    }, [
        productList,
        listModal
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableTypeWrapper, {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Table, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                className: "header",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("th", {
                                        className: "custome-checkbox",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                type: "checkbox",
                                                className: "form-check-input",
                                                id: "all",
                                                onChange: function(e) {
                                                    return selectAllItems(e);
                                                },
                                                checked: !selectedItem.includes(false)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                htmlFor: "all",
                                                className: "form-check-label"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        className: "img",
                                        children: "\uC774\uBBF8\uC9C0"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        className: "name",
                                        children: "\uD488\uBA85"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        className: "sizes",
                                        children: "\uC0AC\uC774\uC988"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        className: "onePrice",
                                        children: "\uB2E8\uAC00"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        className: "quantity",
                                        children: "\uBB36\uC74C \uC218\uB7C9"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        children: "\uD310\uB9E4\uAC00"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        children: "\uC778\uC1C4 \uBE44\uC6A9"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        children: "\uC608\uC0C1 \uD569 \uAC00\uACA9"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                            children: productList && productList.length > 0 && productList.map(function(product, i) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                            className: "custome-checkbox",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: "checkbox",
                                                    className: "form-check-input",
                                                    id: product.pcode,
                                                    onChange: function(e) {
                                                        return selectItem(e, product, i);
                                                    },
                                                    checked: selectedItem[i]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                    className: "form-check-label",
                                                    style: {
                                                        textTransform: "capitalize"
                                                    },
                                                    htmlFor: product.pcode
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            className: "img",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/products/".concat(product.ename, "/").concat(product.pcode, "/"),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: product.main_image,
                                                        alt: product.pname
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            className: "name",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/products/".concat(product.ename, "/").concat(product.pcode, "/"),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    children: product.pname
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            className: "sizes",
                                            children: (product.horizontal != 0 ? product.horizontal : "-") + (product.vertical != 0 ? "X" + product.vertical : "") + (product.height != 0 ? "X" + product.height : "")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                            className: "onePrice",
                                            children: [
                                                (0,splicePrice/* priceComma */.a)(Math.round(Number(product.discount_price) / Number(product.quantity))),
                                                "\uC6D0"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                            className: "quantity",
                                            children: [
                                                (0,splicePrice/* priceComma */.a)(product.quantity),
                                                "\uAC1C"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            className: "price",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PriceBox, {
                                                children: [
                                                    product.salePer > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: product.price && " ".concat((0,splicePrice/* priceComma */.a)(product.price), "\uC6D0")
                                                        })
                                                    }),
                                                    (0,splicePrice/* priceComma */.a)(product.discount_price),
                                                    "\uC6D0"
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                            className: "print_price",
                                            children: [
                                                (0,splicePrice/* priceComma */.a)(Number(product.small_price) * Number(product.quantity)),
                                                "\uC6D0"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                            className: "total_price",
                                            children: [
                                                (0,splicePrice/* priceComma */.a)(Number(product.discount_price) + Number(product.small_price) * Number(product.quantity)),
                                                "\uC6D0"
                                            ]
                                        })
                                    ]
                                }, i);
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BtnWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: "btn",
                    onClick: function() {
                        setConfirmItems([]);
                        setSelectedItem([]);
                        addPrintCart(confirmItems);
                    },
                    children: "\uC120\uD0DD \uACAC\uC801 \uB2F4\uAE30"
                })
            })
        ]
    });
};
var mapStateToProps = function(state) {
    return {};
};
var Print_ProductsList_mapDispatchToProps = {
    closeConfirmModal: action_confirm/* closeConfirmModal */.d6,
    modifyConfirmModal: action_confirm/* modifyConfirmModal */.sR,
    openConfirmModal: action_confirm/* openConfirmModal */._5
};
/* harmony default export */ var Print_ProductsList = ((0,es/* connect */.$j)(mapStateToProps, Print_ProductsList_mapDispatchToProps)(PrintProductsList));

// EXTERNAL MODULE: ./api/getUserInfo.js + 3 modules
var getUserInfo = __webpack_require__(36897);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./utils/seo/SeoMeta.js
var SeoMeta = __webpack_require__(44027);
;// CONCATENATED MODULE: ./pages/customizing/print/index.js
function print_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function print_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return print_arrayLikeToArray(arr);
}
function print_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function print_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                print_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                print_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function print_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function print_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function print_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function print_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            print_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function print_toConsumableArray(arr) {
    return print_arrayWithoutHoles(arr) || print_iterableToArray(arr) || print_unsupportedIterableToArray(arr) || print_nonIterableSpread();
}
function print_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return print_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return print_arrayLikeToArray(o, minLen);
}





















var CustomizingPrintPage = function(param) {
    var _$isLoaded = param.isLoaded, _$isLoading = param.isLoading, _$closeConfirmModal = param.closeConfirmModal, _$modifyConfirmModal = param.modifyConfirmModal, _$openConfirmModal = param.openConfirmModal, userInfo = param.userInfo;
    var router = (0,next_router.useRouter)();
    var ref7 = (0,react.useState)({}), inquiryInputs = ref7[0], setInquiryInputs = ref7[1];
    var ref1 = (0,react.useState)(false), openInquiryModal = ref1[0], setOpenInquiryModal = ref1[1];
    var ref2 = (0,react.useState)(false), openInquiryComplete = ref2[0], setOpenInquiryComplete = ref2[1];
    var ref3 = (0,react.useState)([]), productList = ref3[0], setProductList = ref3[1];
    var ref4 = (0,react.useState)([]), printCartItems = ref4[0], setPrintCartItems = ref4[1];
    var cartRef = (0,react.useRef)(null);
    var listRef = (0,react.useRef)(null);
    var userCompany = (0,react.useMemo)(function() {
        var ref, ref5;
        if (userInfo === null || userInfo === void 0 ? void 0 : (ref = userInfo.Company) === null || ref === void 0 ? void 0 : (ref5 = ref.Data) === null || ref5 === void 0 ? void 0 : ref5.code) {
            var ref6;
            return userInfo === null || userInfo === void 0 ? void 0 : (ref6 = userInfo.Company) === null || ref6 === void 0 ? void 0 : ref6.Data;
        } else {
            return null;
        }
    }, [
        userInfo
    ]);
    var onClickInquiry = function() {
        var _ref = print_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setOpenInquiryModal(function(prev) {
                            return !prev;
                        });
                        setInquiryInputs({});
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onClickInquiry() {
            return _ref.apply(this, arguments);
        };
    }();
    var onChangeInquiry = function(e, id) {
        if (id.includes("file")) {
            setInquiryInputs(print_objectSpread({}, inquiryInputs, print_defineProperty({}, id, e.target.files[0])));
            return;
        }
        if (id === "policy") {
            setInquiryInputs(print_objectSpread({}, inquiryInputs, print_defineProperty({}, id, e.target.checked)));
            return;
        }
        setInquiryInputs(print_objectSpread({}, inquiryInputs, print_defineProperty({}, id, e.target.value)));
    };
    var onClickInquiryComplete = function() {
        setOpenInquiryComplete(function(prev) {
            return !prev;
        });
    };
    var submitInquiry = function() {
        var _ref = print_asyncToGenerator(runtime_default().mark(function _callee() {
            var body, res, ref;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(!inquiryInputs.name || !inquiryInputs.tel || !inquiryInputs.cnt || !inquiryInputs.usages || !inquiryInputs.email || !inquiryInputs.content)) {
                            _ctx.next = 3;
                            break;
                        }
                        (0,common_alert/* failAlert */.qh)("\uD56D\uBAA9\uC744 \uC804\uBD80 \uC785\uB825\uD574\uC8FC\uC138\uC694.");
                        return _ctx.abrupt("return");
                    case 3:
                        if (inquiryInputs.policy) {
                            _ctx.next = 6;
                            break;
                        }
                        (0,common_alert/* failAlert */.qh)("\uC720\uC758\uC0AC\uD56D\uC5D0 \uB3D9\uC758\uD574\uC8FC\uC138\uC694.");
                        return _ctx.abrupt("return");
                    case 6:
                        if (inquiryInputs.tel.match(/^(0[2-8][0-5]?|01[01346-9])-?([1-9]{1}[0-9]{2,3})-?([0-9]{4})$/)) {
                            _ctx.next = 9;
                            break;
                        }
                        (0,common_alert/* failAlert */.qh)("\uC0AC\uC6A9\uAC00\uB2A5\uD55C \uC804\uD654\uBC88\uD638\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694.");
                        return _ctx.abrupt("return");
                    case 9:
                        _$isLoading();
                        body = print_objectSpread({
                            modes: "InquirySet",
                            division: "F",
                            pcode: "P000001"
                        }, inquiryInputs);
                        _ctx.next = 13;
                        return (0,products/* inquirySet */.Bg)(body);
                    case 13:
                        res = _ctx.sent;
                        if (res.Code === "0000") {
                            ;
                            (0,common_alert/* successAlert */.Cq)(((ref = res.Data) === null || ref === void 0 ? void 0 : ref.Msg) || "\uBB38\uC758\uAC00 \uB4F1\uB85D\uB418\uC5C8\uC2B5\uB2C8\uB2E4.");
                            onClickInquiryComplete();
                            onClickInquiry();
                            setInquiryInputs({});
                            _$isLoaded();
                        } else {
                            (0,common_alert/* failAlert */.qh)("\uBB38\uC758 \uB4F1\uB85D\uC5D0 \uC2E4\uD328\uD588\uC2B5\uB2C8\uB2E4.");
                            _$isLoaded();
                        }
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function submitInquiry() {
            return _ref.apply(this, arguments);
        };
    }();
    // 소량 인쇄 상품 리스트
    var fetchProducts = function() {
        var _ref = print_asyncToGenerator(runtime_default().mark(function _callee() {
            var body, res, ref;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        body = {
                            modes: "ProductsListSet"
                        };
                        _ctx.next = 3;
                        return (0,smallPackaging/* smallPackagingAPI */.t)(body);
                    case 3:
                        res = _ctx.sent;
                        if (res.Code === "0000") {
                            ;
                            setProductList((ref = res.Data) === null || ref === void 0 ? void 0 : ref.rows.data);
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function fetchProducts() {
            return _ref.apply(this, arguments);
        };
    }();
    // 견적 카트 상품 불러오기
    var fetchPrintCartItems = function() {
        var items = JSON.parse(sessionStorage.getItem("printCart"));
        if (items && items.length > 0) {
            setPrintCartItems(items);
        }
    };
    // 카트 담기
    var addPrintCart = function(product) {
        var ref;
        if (!(userInfo === null || userInfo === void 0 ? void 0 : (ref = userInfo.Member) === null || ref === void 0 ? void 0 : ref.ukey)) {
            (0,common_alert/* failAlert */.qh)("\uB85C\uADF8\uC778 \uD6C4 \uC774\uC6A9 \uAC00\uB2A5\uD569\uB2C8\uB2E4.");
            router.push("/login");
            return;
        }
        if (printCartItems.find(function(el) {
            return el.pcode === product.pcode;
        })) {
            (0,common_alert/* failAlert */.qh)("\uC774\uBBF8 \uB2F4\uAE34 \uC0C1\uD488\uC785\uB2C8\uB2E4.");
            return;
        }
        (0,common_alert/* successAlert */.Cq)("\uC7A5\uBC14\uAD6C\uB2C8\uC5D0 \uB2F4\uACBC\uC2B5\uB2C8\uB2E4.");
        var tempArr = [
            print_objectSpread({}, product, {
                cnt: 1
            })
        ].concat(print_toConsumableArray(printCartItems));
        setPrintCartItems(tempArr);
        sessionStorage.setItem("printCart", JSON.stringify(tempArr));
        window.scrollTo({
            behavior: "smooth",
            left: 0,
            top: cartRef.current.offsetTop
        });
    };
    // 카트 담긴 상태
    var inCart = function(product) {
        var ref;
        if (!(userInfo === null || userInfo === void 0 ? void 0 : (ref = userInfo.Member) === null || ref === void 0 ? void 0 : ref.ukey)) {
            return false;
        }
        return printCartItems.find(function(el) {
            return el.pcode === product.pcode;
        }) ? true : false;
    };
    (0,react.useEffect)(function() {
        fetchProducts();
        fetchPrintCartItems();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: "\uC18C\uB7C9 \uC778\uC1C4 \uC11C\uBE44\uC2A4 :: \uCE7C\uB81B\uC2A4\uD1A0\uC5B4"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: "https://file.caretbio.com/caretbio/b2c6985b05f7bef24ed2c91965b47455.jpg"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: "https://www.caretstore.co.kr/customizing/print/"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default */.Z, {
                parent: "\uD648",
                sub: "\uC18C\uB7C9 \uC778\uC1C4 \uC11C\uBE44\uC2A4",
                pageTitle: SeoMeta/* SeoMeta.smallPrintService.title */.e.smallPrintService.title,
                pageDesc: SeoMeta/* SeoMeta.smallPrintService.description */.e.smallPrintService.description,
                pageKeyword: SeoMeta/* SeoMeta.smallPrintService.keywords */.e.smallPrintService.keywords,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrintSection, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Print_presenter, {
                        onClickInquiry: onClickInquiry,
                        listRef: listRef,
                        cartRef: cartRef,
                        productList: productList,
                        addPrintCart: addPrintCart,
                        inCart: inCart,
                        userInfo: userInfo,
                        userCompany: userCompany,
                        printCartItems: printCartItems,
                        setPrintCartItems: setPrintCartItems
                    })
                })
            }),
            openInquiryModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(print_PrintInquiryModal, {
                onClickInquiry: onClickInquiry,
                inquiryInputs: inquiryInputs,
                onChangeInquiry: onChangeInquiry,
                submitInquiry: submitInquiry
            }),
            openInquiryComplete && /*#__PURE__*/ (0,jsx_runtime.jsx)(inquiryCompleteModal/* default */.Z, {
                onClickInquiryComplete: onClickInquiryComplete
            })
        ]
    });
};
var print_mapStateToProps = function(state) {
    return {
        userInfo: state.userInfo
    };
};
var print_mapDispatchToProps = {
    isLoading: loading/* isLoading */.h,
    isLoaded: loading/* isLoaded */.k,
    closeConfirmModal: action_confirm/* closeConfirmModal */.d6,
    modifyConfirmModal: action_confirm/* modifyConfirmModal */.sR,
    openConfirmModal: action_confirm/* openConfirmModal */._5
};
/* harmony default export */ var print = ((0,es/* connect */.$j)(print_mapStateToProps, print_mapDispatchToProps)(CustomizingPrintPage));


/***/ }),

/***/ 90651:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
function _typeof(a){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(a){return typeof a}:function(a){return a&&"function"==typeof Symbol&&a.constructor===Symbol&&a!==Symbol.prototype?"symbol":typeof a},_typeof(a)}Object.defineProperty(exports, "__esModule", ({value:!0})),exports["default"]=void 0;var _react=_interopRequireWildcard(__webpack_require__(67294)),_loadPostcode=_interopRequireWildcard(__webpack_require__(52171)),_excluded=["scriptUrl","className","style","defaultQuery","autoClose","errorMessage","onComplete","onClose","onResize","onSearch"];function _getRequireWildcardCache(a){if("function"!=typeof WeakMap)return null;var b=new WeakMap,c=new WeakMap;return(_getRequireWildcardCache=function(a){return a?c:b})(a)}function _interopRequireWildcard(a,b){if(!b&&a&&a.__esModule)return a;if(null===a||"object"!==_typeof(a)&&"function"!=typeof a)return{default:a};var c=_getRequireWildcardCache(b);if(c&&c.has(a))return c.get(a);var d={},e=Object.defineProperty&&Object.getOwnPropertyDescriptor;for(var f in a)if("default"!=f&&Object.prototype.hasOwnProperty.call(a,f)){var g=e?Object.getOwnPropertyDescriptor(a,f):null;g&&(g.get||g.set)?Object.defineProperty(d,f,g):d[f]=a[f]}return d.default=a,c&&c.set(a,d),d}function ownKeys(a,b){var c=Object.keys(a);if(Object.getOwnPropertySymbols){var d=Object.getOwnPropertySymbols(a);b&&(d=d.filter(function(b){return Object.getOwnPropertyDescriptor(a,b).enumerable})),c.push.apply(c,d)}return c}function _objectSpread(a){for(var b,c=1;c<arguments.length;c++)b=null==arguments[c]?{}:arguments[c],c%2?ownKeys(Object(b),!0).forEach(function(c){_defineProperty(a,c,b[c])}):Object.getOwnPropertyDescriptors?Object.defineProperties(a,Object.getOwnPropertyDescriptors(b)):ownKeys(Object(b)).forEach(function(c){Object.defineProperty(a,c,Object.getOwnPropertyDescriptor(b,c))});return a}function _objectWithoutProperties(a,b){if(null==a)return{};var c,d,e=_objectWithoutPropertiesLoose(a,b);if(Object.getOwnPropertySymbols){var f=Object.getOwnPropertySymbols(a);for(d=0;d<f.length;d++)c=f[d],0<=b.indexOf(c)||Object.prototype.propertyIsEnumerable.call(a,c)&&(e[c]=a[c])}return e}function _objectWithoutPropertiesLoose(a,b){if(null==a)return{};var c,d,e={},f=Object.keys(a);for(d=0;d<f.length;d++)c=f[d],0<=b.indexOf(c)||(e[c]=a[c]);return e}function _classCallCheck(a,b){if(!(a instanceof b))throw new TypeError("Cannot call a class as a function")}function _defineProperties(a,b){for(var c,d=0;d<b.length;d++)c=b[d],c.enumerable=c.enumerable||!1,c.configurable=!0,"value"in c&&(c.writable=!0),Object.defineProperty(a,c.key,c)}function _createClass(a,b,c){return b&&_defineProperties(a.prototype,b),c&&_defineProperties(a,c),a}function _inherits(a,b){if("function"!=typeof b&&null!==b)throw new TypeError("Super expression must either be null or a function");a.prototype=Object.create(b&&b.prototype,{constructor:{value:a,writable:!0,configurable:!0}}),b&&_setPrototypeOf(a,b)}function _setPrototypeOf(a,b){return _setPrototypeOf=Object.setPrototypeOf||function(a,b){return a.__proto__=b,a},_setPrototypeOf(a,b)}function _createSuper(a){var b=_isNativeReflectConstruct();return function(){var c,d=_getPrototypeOf(a);if(b){var e=_getPrototypeOf(this).constructor;c=Reflect.construct(d,arguments,e)}else c=d.apply(this,arguments);return _possibleConstructorReturn(this,c)}}function _possibleConstructorReturn(a,b){return b&&("object"===_typeof(b)||"function"==typeof b)?b:_assertThisInitialized(a)}function _assertThisInitialized(a){if(void 0===a)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return a}function _isNativeReflectConstruct(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(a){return!1}}function _getPrototypeOf(a){return _getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function(a){return a.__proto__||Object.getPrototypeOf(a)},_getPrototypeOf(a)}function _defineProperty(a,b,c){return b in a?Object.defineProperty(a,b,{value:c,enumerable:!0,configurable:!0,writable:!0}):a[b]=c,a}var defaultErrorMessage=/*#__PURE__*/_react.default.createElement("p",null,"\uD604\uC7AC Daum \uC6B0\uD3B8\uBC88\uD638 \uC11C\uBE44\uC2A4\uB97C \uC774\uC6A9\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4. \uC7A0\uC2DC \uD6C4 \uB2E4\uC2DC \uC2DC\uB3C4\uD574\uC8FC\uC138\uC694."),defaultStyle={width:"100%",height:400},defaultProps={scriptUrl:_loadPostcode.postcodeScriptUrl,errorMessage:defaultErrorMessage,autoClose:!0},DaumPostcodeEmbed=/*#__PURE__*/function(a){function b(){var a;_classCallCheck(this,b);for(var d=arguments.length,e=Array(d),f=0;f<d;f++)e[f]=arguments[f];return a=c.call.apply(c,[this].concat(e)),_defineProperty(_assertThisInitialized(a),"mounted",!1),_defineProperty(_assertThisInitialized(a),"wrap",/*#__PURE__*/(0,_react.createRef)()),_defineProperty(_assertThisInitialized(a),"state",{hasError:!1}),_defineProperty(_assertThisInitialized(a),"initiate",function(b){if(a.wrap.current){var c=a.props,d=c.scriptUrl,e=c.className,f=c.style,g=c.defaultQuery,h=c.autoClose,i=c.errorMessage,j=c.onComplete,k=c.onClose,l=c.onResize,m=c.onSearch,n=_objectWithoutProperties(c,_excluded),o=new b(_objectSpread(_objectSpread({},n),{},{oncomplete:function oncomplete(b){j&&j(b),h&&a.wrap.current&&a.wrap.current.remove()},onsearch:m,onresize:l,onclose:k,width:"100%",height:"100%"}));o.embed(a.wrap.current,{q:g,autoClose:h})}}),_defineProperty(_assertThisInitialized(a),"onError",function(b){console.error(b),a.setState({hasError:!0})}),a}_inherits(b,a);var c=_createSuper(b);return _createClass(b,[{key:"componentDidMount",value:function componentDidMount(){var a=this.initiate,b=this.onError,c=this.props.scriptUrl;c&&(this.mounted||((0,_loadPostcode.default)(c).then(a).catch(b),this.mounted=!0))}},{key:"render",value:function render(){var a=this.props,b=a.className,c=a.style,d=a.errorMessage,e=this.state.hasError;return/*#__PURE__*/_react.default.createElement("div",{ref:this.wrap,className:b,style:_objectSpread(_objectSpread({},defaultStyle),c)},e&&d)}}]),b}(_react.Component);_defineProperty(DaumPostcodeEmbed,"defaultProps",defaultProps);var _default=DaumPostcodeEmbed;exports["default"]=_default;

/***/ }),

/***/ 60007:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
__webpack_unused_export__ = ({value:!0}),__webpack_unused_export__ = ({enumerable:!0,get:function get(){return _DaumPostcodeEmbed.default}}),__webpack_unused_export__ = ({enumerable:!0,get:function get(){return _useDaumPostcodePopup.default}}),__webpack_unused_export__ = ({enumerable:!0,get:function get(){return _loadPostcode.default}}),exports.ZP=void 0;var _DaumPostcodeEmbed=_interopRequireDefault(__webpack_require__(90651)),_useDaumPostcodePopup=_interopRequireDefault(__webpack_require__(339)),_loadPostcode=_interopRequireDefault(__webpack_require__(52171));function _interopRequireDefault(a){return a&&a.__esModule?a:{default:a}}var _default=_DaumPostcodeEmbed.default;exports.ZP=_default;

/***/ }),

/***/ 52171:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
Object.defineProperty(exports, "__esModule", ({value:!0})),exports["default"]=exports.postcodeScriptUrl=void 0;var postcodeScriptUrl="https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js";exports.postcodeScriptUrl="https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js";var loadPostcode=function(){var a=null;return function(){var b=0<arguments.length&&void 0!==arguments[0]?arguments[0]:postcodeScriptUrl;return a?a:(a=new Promise(function(a,c){var d=document.createElement("script");d.src=b,d.onload=function(){var b,d;return null!==(b=window)&&void 0!==b&&null!==(d=b.daum)&&void 0!==d&&d.Postcode?a(window.daum.Postcode):void c(new Error("Script is loaded successfully, but cannot find Postcode module. Check your scriptURL property."))},d.onerror=function(a){return c(a)},d.id="daum_postcode_script",document.body.appendChild(d)}),a)}}(),_default=loadPostcode;exports["default"]=_default;

/***/ }),

/***/ 339:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
function _typeof(a){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(a){return typeof a}:function(a){return a&&"function"==typeof Symbol&&a.constructor===Symbol&&a!==Symbol.prototype?"symbol":typeof a},_typeof(a)}Object.defineProperty(exports, "__esModule", ({value:!0})),exports["default"]=void 0;var _react=__webpack_require__(67294),_loadPostcode=_interopRequireWildcard(__webpack_require__(52171)),_excluded=["defaultQuery","left","top","popupKey","popupTitle","autoClose","onComplete","onResize","onClose","onSearch","onError"];function _getRequireWildcardCache(a){if("function"!=typeof WeakMap)return null;var b=new WeakMap,c=new WeakMap;return(_getRequireWildcardCache=function(a){return a?c:b})(a)}function _interopRequireWildcard(a,b){if(!b&&a&&a.__esModule)return a;if(null===a||"object"!==_typeof(a)&&"function"!=typeof a)return{default:a};var c=_getRequireWildcardCache(b);if(c&&c.has(a))return c.get(a);var d={},e=Object.defineProperty&&Object.getOwnPropertyDescriptor;for(var f in a)if("default"!=f&&Object.prototype.hasOwnProperty.call(a,f)){var g=e?Object.getOwnPropertyDescriptor(a,f):null;g&&(g.get||g.set)?Object.defineProperty(d,f,g):d[f]=a[f]}return d.default=a,c&&c.set(a,d),d}function ownKeys(a,b){var c=Object.keys(a);if(Object.getOwnPropertySymbols){var d=Object.getOwnPropertySymbols(a);b&&(d=d.filter(function(b){return Object.getOwnPropertyDescriptor(a,b).enumerable})),c.push.apply(c,d)}return c}function _objectSpread(a){for(var b,c=1;c<arguments.length;c++)b=null==arguments[c]?{}:arguments[c],c%2?ownKeys(Object(b),!0).forEach(function(c){_defineProperty(a,c,b[c])}):Object.getOwnPropertyDescriptors?Object.defineProperties(a,Object.getOwnPropertyDescriptors(b)):ownKeys(Object(b)).forEach(function(c){Object.defineProperty(a,c,Object.getOwnPropertyDescriptor(b,c))});return a}function _defineProperty(a,b,c){return b in a?Object.defineProperty(a,b,{value:c,enumerable:!0,configurable:!0,writable:!0}):a[b]=c,a}function _objectWithoutProperties(a,b){if(null==a)return{};var c,d,e=_objectWithoutPropertiesLoose(a,b);if(Object.getOwnPropertySymbols){var f=Object.getOwnPropertySymbols(a);for(d=0;d<f.length;d++)c=f[d],0<=b.indexOf(c)||Object.prototype.propertyIsEnumerable.call(a,c)&&(e[c]=a[c])}return e}function _objectWithoutPropertiesLoose(a,b){if(null==a)return{};var c,d,e={},f=Object.keys(a);for(d=0;d<f.length;d++)c=f[d],0<=b.indexOf(c)||(e[c]=a[c]);return e}function useDaumPostcodePopup(){var a=0<arguments.length&&arguments[0]!==void 0?arguments[0]:_loadPostcode.postcodeScriptUrl;(0,_react.useEffect)(function(){(0,_loadPostcode.default)(a)},[a]);var b=(0,_react.useCallback)(function(b){var c=_objectSpread({},b),d=c.defaultQuery,e=c.left,f=c.top,g=c.popupKey,h=c.popupTitle,i=c.autoClose,j=c.onComplete,k=c.onResize,l=c.onClose,m=c.onSearch,n=c.onError,o=_objectWithoutProperties(c,_excluded);return(0,_loadPostcode.default)(a).then(function(a){var b=new a(_objectSpread(_objectSpread({},o),{},{oncomplete:j,onsearch:m,onresize:k,onclose:l}));b.open({q:d,left:e,top:f,popupTitle:h,popupKey:g,autoClose:i})}).catch(n)},[a]);return b}var _default=useDaumPostcodePopup;exports["default"]=_default;

/***/ }),

/***/ 18357:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "YD": function() { return /* binding */ useInView; }
/* harmony export */ });
/* unused harmony exports InView, defaultFallbackInView, observe */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
"use client";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);

// src/InView.tsx


// src/observe.ts
var observerMap = /* @__PURE__ */ new Map();
var RootIds = /* @__PURE__ */ new WeakMap();
var rootId = 0;
var unsupportedValue = void 0;
function defaultFallbackInView(inView) {
  unsupportedValue = inView;
}
function getRootId(root) {
  if (!root) return "0";
  if (RootIds.has(root)) return RootIds.get(root);
  rootId += 1;
  RootIds.set(root, rootId.toString());
  return RootIds.get(root);
}
function optionsToId(options) {
  return Object.keys(options).sort().filter(
    (key) => options[key] !== void 0
  ).map((key) => {
    return `${key}_${key === "root" ? getRootId(options.root) : options[key]}`;
  }).toString();
}
function createObserver(options) {
  const id = optionsToId(options);
  let instance = observerMap.get(id);
  if (!instance) {
    const elements = /* @__PURE__ */ new Map();
    let thresholds;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        var _a;
        const inView = entry.isIntersecting && thresholds.some((threshold) => entry.intersectionRatio >= threshold);
        if (options.trackVisibility && typeof entry.isVisible === "undefined") {
          entry.isVisible = inView;
        }
        (_a = elements.get(entry.target)) == null ? void 0 : _a.forEach((callback) => {
          callback(inView, entry);
        });
      });
    }, options);
    thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [options.threshold || 0]);
    instance = {
      id,
      observer,
      elements
    };
    observerMap.set(id, instance);
  }
  return instance;
}
function observe(element, callback, options = {}, fallbackInView = unsupportedValue) {
  if (typeof window.IntersectionObserver === "undefined" && fallbackInView !== void 0) {
    const bounds = element.getBoundingClientRect();
    callback(fallbackInView, {
      isIntersecting: fallbackInView,
      target: element,
      intersectionRatio: typeof options.threshold === "number" ? options.threshold : 0,
      time: 0,
      boundingClientRect: bounds,
      intersectionRect: bounds,
      rootBounds: bounds
    });
    return () => {
    };
  }
  const { id, observer, elements } = createObserver(options);
  const callbacks = elements.get(element) || [];
  if (!elements.has(element)) {
    elements.set(element, callbacks);
  }
  callbacks.push(callback);
  observer.observe(element);
  return function unobserve() {
    callbacks.splice(callbacks.indexOf(callback), 1);
    if (callbacks.length === 0) {
      elements.delete(element);
      observer.unobserve(element);
    }
    if (elements.size === 0) {
      observer.disconnect();
      observerMap.delete(id);
    }
  };
}

// src/InView.tsx
function isPlainChildren(props) {
  return typeof props.children !== "function";
}
var InView = class extends react__WEBPACK_IMPORTED_MODULE_0__.Component {
  constructor(props) {
    super(props);
    __publicField(this, "node", null);
    __publicField(this, "_unobserveCb", null);
    __publicField(this, "handleNode", (node) => {
      if (this.node) {
        this.unobserve();
        if (!node && !this.props.triggerOnce && !this.props.skip) {
          this.setState({ inView: !!this.props.initialInView, entry: void 0 });
        }
      }
      this.node = node ? node : null;
      this.observeNode();
    });
    __publicField(this, "handleChange", (inView, entry) => {
      if (inView && this.props.triggerOnce) {
        this.unobserve();
      }
      if (!isPlainChildren(this.props)) {
        this.setState({ inView, entry });
      }
      if (this.props.onChange) {
        this.props.onChange(inView, entry);
      }
    });
    this.state = {
      inView: !!props.initialInView,
      entry: void 0
    };
  }
  componentDidMount() {
    this.unobserve();
    this.observeNode();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
      this.unobserve();
      this.observeNode();
    }
  }
  componentWillUnmount() {
    this.unobserve();
  }
  observeNode() {
    if (!this.node || this.props.skip) return;
    const {
      threshold,
      root,
      rootMargin,
      trackVisibility,
      delay,
      fallbackInView
    } = this.props;
    this._unobserveCb = observe(
      this.node,
      this.handleChange,
      {
        threshold,
        root,
        rootMargin,
        // @ts-ignore
        trackVisibility,
        // @ts-ignore
        delay
      },
      fallbackInView
    );
  }
  unobserve() {
    if (this._unobserveCb) {
      this._unobserveCb();
      this._unobserveCb = null;
    }
  }
  render() {
    const { children } = this.props;
    if (typeof children === "function") {
      const { inView, entry } = this.state;
      return children({ inView, entry, ref: this.handleNode });
    }
    const {
      as,
      triggerOnce,
      threshold,
      root,
      rootMargin,
      onChange,
      skip,
      trackVisibility,
      delay,
      initialInView,
      fallbackInView,
      ...props
    } = this.props;
    return React.createElement(
      as || "div",
      { ref: this.handleNode, ...props },
      children
    );
  }
};

// src/useInView.tsx

function useInView({
  threshold,
  delay,
  trackVisibility,
  rootMargin,
  root,
  triggerOnce,
  skip,
  initialInView,
  fallbackInView,
  onChange
} = {}) {
  var _a;
  const [ref, setRef] = react__WEBPACK_IMPORTED_MODULE_0__.useState(null);
  const callback = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
  const [state, setState] = react__WEBPACK_IMPORTED_MODULE_0__.useState({
    inView: !!initialInView,
    entry: void 0
  });
  callback.current = onChange;
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(
    () => {
      if (skip || !ref) return;
      let unobserve;
      unobserve = observe(
        ref,
        (inView, entry) => {
          setState({
            inView,
            entry
          });
          if (callback.current) callback.current(inView, entry);
          if (entry.isIntersecting && triggerOnce && unobserve) {
            unobserve();
            unobserve = void 0;
          }
        },
        {
          root,
          rootMargin,
          threshold,
          // @ts-ignore
          trackVisibility,
          // @ts-ignore
          delay
        },
        fallbackInView
      );
      return () => {
        if (unobserve) {
          unobserve();
        }
      };
    },
    // We break the rule here, because we aren't including the actual `threshold` variable
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      // If the threshold is an array, convert it to a string, so it won't change between renders.
      Array.isArray(threshold) ? threshold.toString() : threshold,
      ref,
      root,
      rootMargin,
      triggerOnce,
      skip,
      trackVisibility,
      fallbackInView,
      delay
    ]
  );
  const entryTarget = (_a = state.entry) == null ? void 0 : _a.target;
  const previousEntryTarget = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
  if (!ref && entryTarget && !triggerOnce && !skip && previousEntryTarget.current !== entryTarget) {
    previousEntryTarget.current = entryTarget;
    setState({
      inView: !!initialInView,
      entry: void 0
    });
  }
  const result = [setRef, state.inView, state.entry];
  result.ref = result[0];
  result.inView = result[1];
  result.entry = result[2];
  return result;
}

//# sourceMappingURL=index.mjs.map

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,9199,4231,9807,4027,4948,5830,9774,2888,179], function() { return __webpack_exec__(22636); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);